/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

/* global pw_script_vars */


  function getParameterByName(name) {
    var regexS = "[\\?&]" + name + "=([^&#]*)",
      regex = new RegExp(regexS),
      results = regex.exec(window.location.search);
    if (results == null) {
      return "";
    } else {
      return decodeURIComponent(results[1].replace(/\+/g, " "));
    }
  }

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}





(function ($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.

  var Sage = {
    // All pages
    'common': {
      init: function () {
        if ($('.pricingpageform').length > 0) {
          set_up_pricing_form_integration($);
        }
        $('body').on('change', 'select', function () {
          if (this.selectedIndex == 0) {
            $(this).removeClass('something');
          } else {
            $(this).addClass('something');
          }
        });
        if (location.search.match(/subscribe/)) {
          $('#newsletter-modal').modal('show')
        }
        $('input[id^=termsagree]').each(function () {
          var agreecheckbox = $(this);
          var submitbutton = agreecheckbox.closest('form').find('[type=submit]');
          submitbutton.addClass('disabled');
          submitbutton.on('click touchstart', function (e) {
            if (agreecheckbox[0].checked) {
              return true;
            }
            agreecheckbox.addClass('invalid shake');
            setTimeout(function () {
              agreecheckbox.removeClass('shake');
            }, 2000);
            return true;
          });

          agreecheckbox.on('change', function () {
            if (this.checked) {
              $(this).removeClass('invalid');
              submitbutton.removeClass('disabled');
            } else {
              submitbutton.addClass('disabled');
            }
          });
        });

        //open video in modal
        $('.media-and-text .more-video, .hero .more-video, .more.more-video, .media-and-text .play').on('click', function (e) {
          e.preventDefault();
          $('#video-modal .modal-body').attr('data-video-url', $(this).attr('data-video-src'));
          $("#video-modal").modal('show');
        });

        //open request demo modal [menu]
        $('#menu-main-menu li.try-bob-free a').attr('data-toggle','modal');
        $('#menu-main-menu li.try-bob-free a').attr('data-target','#book-demo-modal');
        $('#menu-main-menu li.try-bob-free a').attr('data-ga-event','interested');
        $('#menu-main-menu li.try-bob-free a').attr('data-ga-action','book demo');
        $('#menu-main-menu li.try-bob-free a').attr('data-ga-category','interested');
        //$('#menu-main-menu li.try-bob-free a').attr('data-ga-label','top-nav');

        $('#video-modal [data-toggle="modal"]').on('click', function (e) {
          $('#video-modal').modal('hide');
        });

        if ($('#partner-modal').length > 0) {
          $('#partner-modal').on('show.bs.modal', function (e) {
            var partnertype = $(e.relatedTarget).data('partnertype');
            var options = $(this).find('#Partner_Type__c option');
            var found_option = options.filter(function (i, elm) {
              return elm.value.toLowerCase().indexOf(partnertype.toLowerCase()) > -1
            })[0]
            if (found_option) {
              $(found_option).parent().val(found_option.value)
            }
          });
        }

        // close modal with back button
        $('#partner-modal,#book-demo-modal')
          .on('show.bs.modal', function (e) {
            history.pushState({ modal: $(this).attr('id') }, 'fill the form', '#');
            history.pushState('openmodal', null, '#');
          })
          .on('hide.bs.modal', function (e) {
            history.back();
          });

        window.onpopstate = function (event) {
          if (event.state && event.state.modal) {
            jQuery('#' + event.state.modal).modal('hide');
          }
        };
        // formidable form submit add body class
        $(document).on('focus', 'input,select,textarea', function () {
          $('meta[name=viewport]').attr('content', 'width=device-width, initial-scale=1, maximum-scale=4');
          document.body.style.opacity = 0.9999;
          setTimeout(function () { document.body.style.opacity = 1; }, 100);
        });
        //$(document).on('blur', 'input,select,textarea', function() {
        //  $('meta[name=viewport]').attr('content', 'width=device-width, initial-scale=1, maximum-scale=1');
        //  document.body.style.opacity = 0.9999;
        //  setTimeout(function() { document.body.style.opacity = 1;}, 100);
        //});
        $(document).on('frmFormComplete', function (event, form, response) {
          var form_key = $(form).find('input[name="form_key"]').val();
          $('body').addClass('frm-submitted frm-submitted-' + form_key);
        });
        // formidable form submit add body class
        $('.topbannerslider .slides').slick({
          fade: true,
          arrows: false,
          adaptiveHeight: true,
          autoplay: true,
          dots: true,
          slide: '.slide'
        });
        $('#survey-icons-wrapper').slick({
          mobileFirst: false,
          responsive: [
            {
              breakpoint: 5000,
              settings: 'unslick'
            },
            {
              breakpoint: 768,
              settings: {
                adaptiveHeight: true,
                slidesToShow: 1
              }
            }
          ]
        });
        //events mobile
        $(' .recentevents > ul').slick({
          mobileFirst: true,
          adaptiveHeight: true,
          responsive: [
            {
              breakpoint: 501,
              settings: 'unslick'
            },
            {
              breakpoint: 500,
              settings: {
                slidesToScroll: 1,
                slidesToShow: 1,
              }
            }
          ]
        });
        $('.events').on('click', '.recentevents li,.upcoming-event', function (e) {
          if (window.innerWidth && window.innerWidth < 600) return;
          if (e.target.tagName == 'A' || e.target.tagName == 'BUTTON') return
          e.preventDefault();
          var link = $(this).find('a')
          document.location.href = link.attr('href');
        });
        $('.single-event').on('click', '.recentevents li', function (e) {
          if (window.innerWidth && window.innerWidth < 600) return;
          if (e.target.tagName == 'A' || e.target.tagName == 'BUTTON') return
          e.preventDefault();
          var link = $(this).find('a')
          document.location.href = link.attr('href');
        });

        $('body').on('click', '[data-action="scroll"]', function (e) {
          e.preventDefault();
          var elm = $($(this).attr('data-target'));
          if (elm.length === 0) {
            return;
          }
          $('html,body').animate({
            scrollTop: elm.offset().top
          }, 1000, function () {
            elm.find('input.mktoRequired,input[required]').first().focus();
          });
        });
        $('#landingpage-features-wrapper').slick({
          mobileFirst: false,
          responsive: [
            {
              breakpoint: 5000,
              settings: 'unslick'
            },
            {
              breakpoint: 768,
              settings: {
                adaptiveHeight: true,
                slidesToShow: 1
              }
            }
          ]
        });
        $('.morecases .cs,.cs-selected .width').on('click', function (e) {
          e.preventDefault();
          var a = $(this).find('a');
          location.href = a.attr('href');
        });
        $('.morecases > div').slick({
          arrows: true,
          slidesToScroll: 1,
          slidesToShow: 1,
          mobileFirst: true,
          draggable: false,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            }
          ]
        });
        $('.landing-testimonials-section .container').slick({
          adaptiveHeight: true
        });

        $('.clientlogos figure.visible-md-block img:lt(5)').wrapAll('<div class=imgwrapper></div>');
        $('.clientlogos figure.visible-md-block img:gt(4)').wrapAll('<div class=imgwrapper></div>');
        $('.clientlogos figure.visible-md-block').slick({
          autoplay: true,
          arrows: false,
          autoplaySpeed: 6000,
          speed: 3000,
          fade: false,
        });

        $('.blogposts .list').slick({
          slide: 'div',
          arrows: false,
          mobileFirst: true,
          draggable: false,
          responsive: [
            {
              breakpoint: 990,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 530,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 475,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
        $('.a2a_kit').on('click', 'a', function (e) {
          e.preventDefault();
          window.open($(this).attr('href'), 'share', "width=500, height=500, toolbar=no,menubar=no,location=no");
        });

        var totalslides = $('.textimageslider .container .slide').length;
        //      $('.textimageslider').append('<nav class=container><button type=button class=prev></button><span></span><button type=button class=next></button></nav>')
        $('.textimageslider').append('<nav class="onimage container"><button type=button class=prev></button><button type=button class=next></button></nav>');

        $('.textimageslider .container')
          .on('afterChange init', function (event, slick, slide) {
            //        var current = slide || 0
            //        $('.textimageslider nav span').text( parseInt(current+1) + ' of ' + totalslides )
          })
          .slick({
            adaptiveHeight: true,
            slide: '.row',
            draggable: false,
            nextArrow: '.textimageslider nav .next',
            prevArrow: '.textimageslider nav .prev',
            fade: window.innerWidth > 500,
            swipe: true,
            arrows: true,
          });

        // material form handlers
        $('select,input,textarea').each(function () {
          if ($(this).closest('.material').length === 0) {
            return;
          }
          $(this).attr('value', $(this).val());
        });
        $('body').on('change', '.material select', function () {
          $(this).attr('value', $(this).val());
        });
        $('body').on('keyup', '.material input, .material textarea', function () {
          $(this).attr('value', $(this).val());
        });
        // material form handlers

        var utm_referrals = {};


        ['utm_creative', 'utm_lp', 'utm_geo', 'utm_campaign', 'utm_medium', 'utm_source', 'utm_term', 'utm_content', 'utm_referrer', 'gclid', 'fbclid', 'first_page_seen', 'ref', 'adid', 'ad_id'].forEach(function (param_name) {
          var val = getParameterByName(param_name);
          //console.log(param_name);
          //console.log(val);

          if (val === null || val === '') return;
          var val = val.replace(/ /g, "_");
          var val = val.replace(/%2B/g, "_");
          var val = val.replace(/\+/g, "_");
          utm_referrals[param_name] = val;

          //console.log('after change '+param_name);
          //console.log('after change '+val);
        });


        /* Experiement JS */

        mainCta = $('.home .hero p.trybobfreewrapper>button');
        mainCtaType = mainCta.attr('data-target');
        if (mainCtaType == "#watch-modal") {
          createCookie("experiment","Homepage CTA Watch Demo",90);
        } else if (mainCtaType == "#book-demo-modal") {
          createCookie("experiment","Homepage CTA Book Demo",90);
        }


        var existingUTM = getCookie('utm_referrals_cookie');

        if (existingUTM) {
          //
          //do nothing
          //
        } else {
          //first page seen
          var currentURL = 'https://' + window.location.hostname + window.location.pathname;
          utm_referrals['first_page_seen'] = currentURL;

          //referrer logic
          // take value from utm_referrer url param if defined.
          // otherwise look for ref url param if defined/
          // otherwise default to document.referrer
          var utmREF = getParameterByName('utm_referrer');
          if (utmREF === null || utmREF === '') {
                refVal = getParameterByName('ref');
                if (refVal === null || refVal === '') {
                    //console.log('referrer: '+document.referrer);
                    utm_referrals['utm_referrer'] = document.referrer;
                } else {
                  utm_referrals['utm_referrer'] = refVal;
                }
          } else {
            utm_referrals['utm_referrer'] = utmREF;
          }

          // if (getCookie('experiment')) {
          //   utm_referrals.experiment = getCookie('experiment')
          // }
        }

        var utm_content = utm_referrals.utm_content;
        if (jQuery.isEmptyObject(utm_referrals) === false) {
          if (typeof utm_content !== 'undefined') {
            if (utm_content.match("newHP$")) {
              if ($('body').hasClass('page-template-template-home-php') || $('body').hasClass('page-template-template-alternate-homepage-php')) {
                var menu_id = $('#navbarCollapse').attr('data-menu-id');
                var page_link = location.pathname;
                utm_referrals.menu_id = menu_id;
                utm_referrals.page_link = page_link;
              }
            }
          }

          $.ajax({
            type: 'POST',
            url: pw_script_vars.ajaxurl,
            data: {
              action: 'set_utm_referral_cookie',
              utm_referrals: utm_referrals
            },
            success: function (data) {
              if (data !== '' && utm_content && utm_content.match("newHP$") !== null) {
                $('a.brand').attr('href', location.protocol + '//' + location.host + location.pathname);
              }
            }
          });
        }

        // pass UTM to register , but this only work
        $('body').on('click', 'a[href="https://app.hibob.com/register"]', function () {
          $(this).attr('href', $(this).attr('href') + location.search);
        });

        $('body').on('click', '#payee-form button.submit-form', function (e) {
          e.preventDefault();
          var submit_text = $('#payee-form').find('button').attr('data-text');
          if ($(this).hasClass('reset-form')) {

            $('#payee-form').find('#payee-number-label').show();
            $('#payee-form').find('input#district-code').show();
            $('#payee-form').find('input#code').show();
            $('#payee-form').find('.divider').show();
            $('#payee-form').find('button').text(submit_text).removeClass('reset-form');
            $('#payee-form').find('#staging-date').hide().val('');
            $('#payee-form').find('#staging-date-label').hide();
          } else {
            var district_code = $('#payee-form').find('input#district-code').val();
            var code = $('#payee-form').find('input#code').val();

            $.ajax({
              type: 'POST',
              url: pw_script_vars.ajaxurl,
              data: {
                action: 'get_staging_date',
                district_code: district_code,
                code: code
              },
              success: function (data) {
                if (data) {
                  $('#payee-form').find('#payee-number-label').hide();
                  $('#payee-form').find('input#district-code').hide();
                  $('#payee-form').find('input#code').hide();
                  $('#payee-form').find('.divider').hide();
                  $('#payee-form').find('button').addClass('reset-form').text('reset');
                  $('#payee-form').find('#staging-date').show().val(data);
                  $('#payee-form').find('#staging-date-label').show();
                  analytics.track('button - staging-date', {
                    "type": "track",
                    label: submit_text,
                    category: 'interested',
                    "properties": {
                      "action": 'button - staging-date'
                    }
                  });

                } else {
                  $('#payee-form').find('input#district-code').val('');
                  $('#payee-form').find('input#code').val('').attr('placeholder', 'Please try again');
                }
              }
            });
          }

          return false;
        });

        var total_animated_words = jQuery('.animated-text-container span').length;
        var animation_duration = (10 * total_animated_words) / 5;
        var start_frame, animation_data;

        var count = 1;
        for (var i = 1; i <= total_animated_words; i++) {
          if (count === 1) {
            start_frame = jQuery('.animated-text-container span:nth-child(' + (i - 1) + ')').attr('data-remove-frame');
            if (start_frame === undefined) {
              start_frame = 0;
            }
            animation_data = Animations.bottom_bottom(i, start_frame);
            $.keyframe.define([animation_data.bottom_bottom]);

            jQuery('.animated-text-container span:nth-child(' + i + ')').attr('data-remove-frame', animation_data.remove_frame);

          } else if (count === 2) {

            start_frame = jQuery('.animated-text-container span:nth-child(' + (i - 1) + ')').attr('data-remove-frame');
            animation_data = Animations.top_left(i, start_frame);
            $.keyframe.define([animation_data.top_left]);
            jQuery('.animated-text-container span:nth-child(' + i + ')').attr('data-remove-frame', animation_data.remove_frame);

          } else if (count === 3) {
            start_frame = jQuery('.animated-text-container span:nth-child(' + (i - 1) + ')').attr('data-remove-frame');
            animation_data = Animations.bottom_right(i, start_frame);
            $.keyframe.define([animation_data.bottom_right]);
            jQuery('.animated-text-container span:nth-child(' + i + ')').attr('data-remove-frame', animation_data.remove_frame);


          } else if (count === 4) {
            start_frame = jQuery('.animated-text-container span:nth-child(' + (i - 1) + ')').attr('data-remove-frame');
            animation_data = Animations.top_bottom(i, start_frame);
            $.keyframe.define([animation_data.top_bottom]);
            jQuery('.animated-text-container span:nth-child(' + i + ')').attr('data-remove-frame', animation_data.remove_frame);
            count = 0;
          }
          count++;
          jQuery('.animated-text-container span:nth-child(' + i + ')').css('animation', 'cycle-' + i + ' ' + animation_duration + 's ease-in-out infinite');
        }
        function createCookie(name, value, days) {
          var expires;

          if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
          } else {
            expires = "";
          }
          document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
        }

        function readCookie(name) {
          var nameEQ = encodeURIComponent(name) + "=";
          var ca = document.cookie.split(';');
          for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') { c = c.substring(1, c.length); }
            if (c.indexOf(nameEQ) === 0) {
              return decodeURIComponent(c.substring(nameEQ.length, c.length));
            }
          }
          return null;
        }

        function eraseCookie(name) {
          createCookie(name, "", -1);
        }
        if ($('body').hasClass('israel') || $('body').hasClass('il') || $('body').hasClass('isr')) {
          var cookie_value = readCookie('show_modal');
          //            if(cookie_value !== 'set') {
          //                createCookie('show_modal', 'set', '1');
          $('#myModalhome12').modal("show");
          analytics.track('open popup', {
            type: "track",
            event: 'form opens',
            label: 'form-left',
            category: 'IL site popup',
            properties: {
              "action": 'open popup'
            }
          });
          //            }
        }

        $('#myModalhome12 button.close').on('click', function (e) {
          e.preventDefault();
          $('#myModalhome12').modal("hide");
          analytics.track('click window - close popup', {
            "type": "track",
            "event": 'close form by X',
            label: 'form-left',
            category: 'IL site popup',
            "properties": {
              "action": 'click window - close popup'
            }
          });
          return false;
        });

        $('.center-image .button-text a.section-btn').on('click', function () {
          analytics.track('click - Free Trial Form Submission', {
            "type": "track",
            "event": 'click on tange button',
            label: 'https://app.hibob.com/registration',
            category: 'IL site popup - Free Trial Sign Up',
            "properties": {
              "action": 'click - Free Trial Form Submission'
            }
          });
        });

        var window_width = $(window).width();
        $('nav ul li.menu-item-has-children>a').click(function (e) {
          e.preventDefault();
          $(this).parent().toggleClass('show');
          $(this).parent().children('ul').stop().slideToggle(300);
          return false;
        });

        if (window_width <= 768) {
          $("#request-invite-modal").on("shown.bs.modal", function () {
            $('body>.intercom-container').hide();
          });

          $("#request-invite-modal").on("hide.bs.modal", function () {
            $('body>.intercom-container').show();
          });


          $('body').on('click', '.learn-more-container', function (e) {
            $(this).parents('.item.active').find('.hide-mobile-container').show();
            $(this).hide();
            return false;
          });

          $('#request-invite-modal .inner-form-container button').on('touchstart', function (e) {
            e.preventDefault();
            if ($.trim($("#request-invite-modal #name").val()) === "" || $.trim($("#request-invite-modal #email").val()) === "") {
              alert('Name and Email are required fields');
              return false;
            } else {
              $('#request-invite-form').trigger('submit');
            }
          });

          $('a[data-toggle="modal"]').on('touchstart', function (e) {
            e.preventDefault();
            $("#request-invite-modal").modal('show');
            return false;
          });

        }

        $(document).on('click', '.page-template-template-compliance-hub a', function (e) {
          if (this.hash !== "") {
            event.preventDefault();
            var hash = this.hash;
            var offset = 4;
            var window_width = $(window).width();
            if (window_width > 767) {
              offset = 80;
            }

            $('body, html').animate({
              scrollTop: $(hash).offset().top - offset
            }, 700);
          }
        });

        $(document).on('click', '#anchor-carousel .item a', function (e) {
          e.preventDefault();
          var value = jQuery(this).attr('href');
          jQuery("body, html").animate({
            scrollTop: jQuery(value).offset().top - 74
          }, 600);
        });

        if ( !$("body").is(".features-template-default") ) {
            console.log('scrolling');
            var hashValue = window.location.hash.substr(1);
            if (hashValue !== undefined && hashValue !== '' && jQuery('#' + hashValue).length) {
              jQuery("body, html").animate({
                scrollTop: jQuery('#' + hashValue).offset().top - 74
              }, 600);
            }
        }

        if (localStorage.getItem('cookie-set') === 'set') {
          $('#cookies-container').remove();
          $('header').removeClass('cookie-unaccepted').attr('data-cookie-exists', '');
        } else {
          $('#cookies-container').fadeIn('500');
          if ($('#cookies-container').length > 0) {
            $('header').addClass('cookie-unaccepted').attr('data-cookie-exists', 'cookie-unaccepted');
          }
        }
        var current_page_url = window.location.href;
        if (current_page_url.indexOf("#invite-bob") > -1) {
          $("#request-invite-modal").modal('show');
        }
        // Iterate over each select element
        $('select#company-size').each(function () {

          // Cache the number of options
          var $this = $(this),
            numberOfOptions = $(this).children('option').length;

          // Hides the select element
          $this.addClass('s-hidden');

          // Wrap the select element in a div
          $this.wrap('<div class="select"></div>');

          // Insert a styled div to sit over the top of the hidden select element
          $this.after('<div class="styledSelect"></div>');

          // Cache the styled div
          var $styledSelect = $this.next('div.styledSelect');

          // Show the first select option in the styled div
          $styledSelect.text($this.children('option').eq(0).text());

          // Insert an unordered list after the styled div and also cache the list
          var $list = $('<ul />', {
            'class': 'options'
          }).insertAfter($styledSelect);

          // Insert a list item into the unordered list for each select option
          for (var i = 0; i < numberOfOptions; i++) {
            if ($this.children('option').eq(i).val() !== '') {
              $('<li />', {
                text: $this.children('option').eq(i).text(),
                rel: $this.children('option').eq(i).val()
              }).appendTo($list);
            }
          }

          // Cache the list items
          var $listItems = $list.children('li');

          // Show the unordered list when the styled div is clicked (also hides it if the div is clicked again)
          $styledSelect.click(function (e) {
            e.stopPropagation();
            if ($('.styledSelect').hasClass('active')) {
              $('.styledSelect').removeClass('active').next('ul.options').hide();
            } else {
              $('.styledSelect').addClass('active').next('ul.options').show();
            }
          });

          // Hides the unordered list when a list item is clicked and updates the styled div to show the selected list item
          // Updates the select element to have the value of the equivalent option
          $listItems.click(function (e) {
            e.stopPropagation();
            $styledSelect.text($(this).text()).removeClass('active');
            $this.val($(this).attr('rel'));
            $list.hide();
            /* alert($this.val()); Uncomment this for demonstration! */
          });

          // Hides the unordered list when clicking outside of it
          $(document).click(function () {
            $styledSelect.removeClass('active');
            $list.hide();
          });

        });

        if ($('#navbarCollapse ul li.free-trial a').attr('href') === 'https://app.hibob.com/registration') {
          $('#navbarCollapse ul li.free-trial a').attr('data-ga-event', 'interested');
          $('#navbarCollapse ul li.free-trial a').attr('data-ga-action', 'text - menu');
        } else {
          $('#navbarCollapse ul li.free-trial a').attr('data-ga-event', 'Menu Button');
          $('#navbarCollapse ul li.free-trial a').attr('data-ga-action', 'click - ' + $('#navbarCollapse ul li.free-trial a').attr('href'));
        }


        jQuery.urlParam = function (name) {
          var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
          if (results === null) {
            return null;
          }
          else {
            return results[1] || 0;
          }
        };

        function redirecttoLink(url, blank) {
          var redirect_url = url;
          var params       = '';
          var experiment   = getCookie('experiment');
          var utm_campaign = jQuery.urlParam('utm_campaign');
          var utm_content  = jQuery.urlParam('utm_content');
          var utm_medium   = jQuery.urlParam('utm_medium');
          var utm_source   = jQuery.urlParam('utm_source');
          var utm_term     = jQuery.urlParam('utm_term');
          var utm_lp       = jQuery.urlParam('utm_lp');
          var utm_geo      = jQuery.urlParam('utm_geo');
          var utm_creative = jQuery.urlParam('utm_creative');
          var append_url   = (redirect_url.indexOf("?") > -1) ? '&' : '?';

          $(document).find('a#test-redirect').remove();
          $('body').append('<a id="test-redirect" href="' + redirect_url + '" target="' + blank + '"></a>');
          if (experiment || utm_lp || utm_geo || utm_creative || utm_campaign !== null || utm_content !== null || utm_medium !== null || utm_source !== null || utm_term !== null) {
            redirect_url = redirect_url + append_url;
            params = { utm_mq_1:experiment, utm_lp: utm_lp, utm_geo: utm_geo, utm_creative: utm_creative, utm_campaign: utm_campaign, utm_content: utm_content, utm_medium: utm_medium, utm_source: utm_source, utm_term: utm_term };
            var str = jQuery.param(params);
            redirect_url = redirect_url + str;
            $('body').find('a#test-redirect').attr('href', redirect_url);
            $(document).find('a#test-redirect')[0].click();
            $(document).find('a#test-redirect').remove();
          } else {
            jQuery.ajax({
              type: 'POST',
              url: pw_script_vars.ajaxurl,
              async: false,
              dataType: "json",
              data: {
                action: 'get_utm_cookies_value'
              },
              success: function (utm_referrals) {
                if (utm_referrals) {
                  redirect_url = redirect_url + append_url;
                  var str = jQuery.param(utm_referrals);
                  redirect_url = redirect_url + str;
                  $('body').find('a#test-redirect').attr('href', redirect_url);
                  $(document).find('a#test-redirect')[0].click();
                } else {
                  $(document).find('a#test-redirect')[0].click();
                }
              }
            });
          }

        }

        $('#mobile-app-wrapper .success-content a.red-btn').on('click', function () {
          analytics.track('click - return to site', {
            "type": "track",
            label: 'BACK TO hibob.com',
            category: 'mobile default',
            "properties": {
              "action": 'click - return to site'
            }
          });
          location.href = this.href;
        });

        $('header').find('.sticky-hide a').attr('data-ga-event', 'interested');
        $('header').find('.sticky-hide a').attr('data-ga-action', 'app referral');

        $('header').find('.login-menu-header a').attr('data-ga-event', 'interested');
        $('header').find('.login-menu-header a').attr('data-ga-action', 'app login');


        jQuery('.stage-button-container a').click(function (event) {
          var label = jQuery(this).attr('title');
          analytics.track('button - stages', {
            "type": "track",
            label: label,
            category: 'interested',
            "properties": {
              "action": 'button - stages'
            }
          });
        });
        jQuery('#footer-contact-section a').click(function (event) {
          var label = jQuery(this).attr('title');
          analytics.track('button - contact', {
            "type": "track",
            label: label,
            category: 'interested',
            "properties": {
              "action": 'button - contact'
            }
          });
        });
        var text_label = '';
        jQuery('.banner-content-container').find('.sub-fields.button a').click(function () {
          text_label = jQuery(this).text();
          text_label = text_label.trim();
        });
        jQuery('.section-content-container').find('.section-button-text a').click(function () {
          text_label = jQuery(this).text();
          text_label = text_label.trim();
        });

        jQuery('.footer-signup-section').find('.footer-signup-container a').click(function () {
          text_label = jQuery(this).text();
          text_label = text_label.trim();
        });

        jQuery('.section-row').find('.signup-container.signup-section a').click(function () {
          text_label = jQuery(this).text();
          text_label = text_label.trim();
        });

        jQuery('.plan-inner-container').find('.button-text a').click(function () {
          text_label = jQuery(this).text();
          text_label = text_label.trim();
        });

        jQuery('#registration-modal').on('shown.bs.modal', function (event) {

          if (text_label === '') {
            text_label = 'Try Bob free';
          }
          analytics.track('app referral', {
            "type": "track",
            "event": "interested",
            label: text_label,
            category: 'interested',
            "properties": {
              "action": 'app referral',
              "url": ''
            }
          });
          text_label = '';
        });

        $('body').on('click touchstart', 'button[data-ga-action]', function (e) {
          analytics.track($(this).attr('data-ga-action'), {
            type: "track",
            label: $(this).attr('data-ga-label'),
            category: 'interested'
          });
        });

        jQuery('#menu-main-menu .try-bob-free a').click(function(e){
            e.preventDefault();
            $("#book-demo-modal").modal('show');
        });

        jQuery('body').on('click','a[href="#request-demo"]',function (event) {
          var ga_category = jQuery(this).attr('data-ga-category');
          var ga_event = jQuery(this).attr('data-ga-event');
          var ga_action = jQuery(this).attr('data-ga-action');
          var ga_label = jQuery(this).attr('data-ga-label');
          analytics.track(ga_action, {
                    "type": "track",
                    "event": ga_event,
                    label: ga_label,
                    category: ga_category,
                    "properties": {
                      "action": ga_action,
                    }
          });
        });

        jQuery('body').on('click', 'a[href^="http://"],a[href^="https://"]', function (event) {
          if (jQuery(this).not('#test-redirect, #registration-via-video').length > 0) {
            var url = this.href;
            var ga_event = jQuery(this).attr('data-ga-event');
            var ga_value = jQuery.trim(jQuery(this).text());
            var ga_action = jQuery(this).attr('data-ga-action');
            var location = 'content ';
            var ga_label = jQuery(this).attr('title');
            var data_ga_label = $(this).attr('data-ga-label');
            if (data_ga_label) {
              ga_label = data_ga_label;
            }

            if ($(this).parents('header').length > 0) {
              location = 'header';
            } else if ($(this).parents('footer').length > 0 || $(this).parents('.footer-signup-container').length > 0) {
              location = 'footer';
            } else if ($(this).parents('nav').length > 0) {
              location = 'menu';
            }

            if ($(window).width() <= 768) {
              if (url === 'https://app.hibob.com/registration') {
                analytics.track('app referral', {
                  "type": "track",
                  "event": "interested",
                  label: ga_label,
                  category: 'interested',
                  "properties": {
                    "action": 'app referral',
                    "url": url
                  }
                });

                if ($('body').hasClass('page-template-template-partners-landing-page-php')) {
                  event.preventDefault();
                  event.stopPropagation();
                  url = 'https://www.hibob.com/contact-us';
                  redirecttoLink(url, '');
                } else {
                  url = window.location.protocol + '//' + window.location.hostname + '/mobile-app';
                }

              }
            }

            if (url === 'https://blog.hibob.com/') {
              ga_event = 'interested';
            }

            if (url === 'https://app.hibob.com/registration') {
              if (ga_value === 'Start now') {
                ga_value = ga_value + ' - pricing';
              } else if (ga_value === 'Sign Up') {
                ga_value = ga_value + ' - pricing';
              } else {
                ga_value = 'button - ' + location + ' - ' + ga_value;
              }

            }
            if ($(this).parent().hasClass('login-menu-header')) {
              ga_value = 'menu';
            }

            if (
              (ga_event != null && ga_event !== '') ||
              $(this).parent().hasClass('sticky-hide') ||
              $(this).parent().hasClass('try-bob-free') ||
              $(this).parents('#video-modal').length > 0) {
              event.preventDefault();
              event.stopPropagation();

              if (url === 'https://app.hibob.com/register') {
                if (ga_label === '') {
                  ga_label = 'Try Bob free';
                }
                analytics.track('app referral', {
                  "type": "track",
                  "event": "interested",
                  label: ga_label,
                  category: 'interested',
                  "properties": {
                    "action": 'app referral',
                    "url": ''
                  }
                });
              } else {
                if (ga_event != null && ga_event !== '') {
                  analytics.track(ga_action, {
                    "type": "track",
                    "event": ga_event,
                    label: ga_value,
                    category: ga_event,
                    "properties": {
                      "action": ga_action,
                      "url": url
                    }
                  });
                }
              }

              if (url.indexOf('hibob.com') !== -1 || url.indexOf('app.hibob.com') !== -1) {
                if (url.indexOf('app.hibob.com') !== -1 && !$(this).parent().hasClass('login-menu-header')) {
                  redirecttoLink(url, '_blank');
                } else {
                  if ($(this).attr('target') == '_blank') {
                    redirecttoLink(url, '_blank');
                  } else {
                    redirecttoLink(url, '');
                  }
                }
              } else {
                redirecttoLink(url, '_blank');
              }
            }
          }
        });

        // Iterate over each select element
        $('.mc_interest').attr('tabindex', "1");
        $('.mc_interest select').each(function () {

          // Cache the number of options
          var $this = $(this),
            numberOfOptions = $(this).children('option').length;

          // Hides the select element
          $this.addClass('s-hidden');

          // Wrap the select element in a div
          $this.wrap('<div class="select" tabindex="1"></div>');

          // Insert a styled div to sit over the top of the hidden select element
          $this.after('<div class="styledSelect" tabindex="1"></div>');

          // Cache the styled div
          var $styledSelect = $this.next('div.styledSelect');

          // Show the first select option in the styled div
          $styledSelect.text('Select your Interest');

          // Insert an unordered list after the styled div and also cache the list
          var $list = $('<ul />', {
            'class': 'options'
          }).insertAfter($styledSelect);

          // Insert a list item into the unordered list for each select option
          for (var i = 0; i < numberOfOptions; i++) {
            if ($this.children('option').eq(i).val() !== '') {
              $('<li />', {
                text: $this.children('option').eq(i).text(),
                rel: $this.children('option').eq(i).val()
              }).appendTo($list);
            }
          }

          // Cache the list items
          var $listItems = $list.children('li');

          // Show the unordered list when the styled div is clicked (also hides it if the div is clicked again)
          $styledSelect.click(function (e) {
            e.stopPropagation();
            if ($('.mc_interest .styledSelect').hasClass('active')) {
              $('.mc_interest  .styledSelect').removeClass('active').next('ul.options').hide();
            } else {
              $('.mc_interest  .styledSelect').addClass('active').next('ul.options').show();
            }
          });

          // Hides the unordered list when a list item is clicked and updates the styled div to show the selected list item
          // Updates the select element to have the value of the equivalent option
          $listItems.click(function (e) {
            e.stopPropagation();
            $styledSelect.text($(this).text()).removeClass('active');
            $this.val($(this).attr('rel'));
            $list.hide();
            /* alert($this.val()); Uncomment this for demonstration! */
          });

          // Hides the unordered list when clicking outside of it
          $(document).click(function () {
            $styledSelect.removeClass('active');
            $list.hide();
          });

        });

        $('body').on('click', '.navbar-toggle', function () {
          $('body').find('#navbarCollapse').addClass('in');
          $('header').css('overflow', 'visible');
          $('body').css('overflow', 'hidden').addClass('menuopened');
        });
        $('body').on('click', '.close-navbar', function () {
          $('body').find('#navbarCollapse').removeClass('in');
          $('header').delay(500).queue(function (next) {
            $('header').css('overflow', 'hidden');
            next();
          });
          $('body').css('overflow', 'auto').removeClass('menuopened');
        });

        $("#request-invite-modal").on("shown.bs.modal", function () {
          //            ga('send', 'event', 'interested', 'button', current_page_url);
          analytics.track('button', {
            "type": "track",
            "event": 'interested',
            label: '',
            category: 'interested',
            "properties": {
              "action": 'button'
            }
          });
        });

        $("#request-invite-modal").on("hide.bs.modal", function () {
          if ($('#request-invite-form').is(':visible')) {
            analytics.track('button', {
              "type": "track",
              "event": 'interested',
              label: '',
              category: 'interested',
              "properties": {
                "action": 'button'
              }
            });
            //                ga('send', 'event', 'interested', 'button', current_page_url);
          }
        });

        $('#request-invite-form').on('submit', function (e) {
          e.preventDefault();
          analytics.identify({
            name: $(".form_name").val(),
            email: $(".form_email").val(),
            company: $(".form_company").val(),
            company_size: $(".form_company_size").val()
          });
          analytics.track('Signed For Beta');
          $('#request-invite-modal .form-container').hide();
          $('#request-invite-modal .thankyou-container').show();
          var img = document.createElement("img");
          var google_conversion_id = 882207018;
          var google_conversion_language = "en";
          var google_conversion_format = 3;
          var google_conversion_color = "ffffff";
          var google_conversion_label = "z79JCIau42YQqtLVpAM";
          var google_remarketing_only = false;
          var trackingUrl = "http://www.googleadservices.com/pagead/conversion/" + google_conversion_id;
          trackingUrl += "/?label=" + google_conversion_label;
          trackingUrl += "&guid=ON&script=0";
          img.src = trackingUrl;
          // Add the image to the page
          document.body.appendChild(img);

          // Don't display the image
          img.style = "display: none;";
          //            ga('send', 'event', 'interested', 'button', current_page_url);
          analytics.track('button', {
            "type": "track",
            "event": 'interested',
            label: '',
            category: 'interested',
            "properties": {
              "action": 'button'
            }
          });
          return false;
        });

        $('#request-invite-form .required-field input').focusin(function () {
          $(this).parents('.required-field').addClass('hide-pseudo');
        });

        $('#request-invite-form .required-field input').focusout(function () {
          if ($(this).val() === '') {
            $(this).parents('.required-field').removeClass('hide-pseudo');
          }
        });

        $('.contact-page-container .frm_required_field input, #partner-form-container .frm_required_field input').focusin(function () {
          $(this).parents('.frm_required_field').addClass('hide-pseudo');
        });

        $('.contact-page-container .frm_required_field input, #partner-form-container .frm_required_field input').focusout(function () {
          if ($(this).val() === '') {
            $(this).parents('.frm_required_field').removeClass('hide-pseudo');
          }
        });


        $('#mc_signup .mc_merge_var input').focusin(function () {
          $(this).parents('.mc_merge_var').addClass('hide-pseudo');
        });

        $('#mc_signup .mc_merge_var input').focusout(function () {
          if ($(this).val() === '') {
            $(this).parents('.mc_merge_var').removeClass('hide-pseudo');
          }
        });

        $('.request-button a').on('click', function (e) {
          e.preventDefault();
          $("#request-invite-modal").modal('show');
          return false;
        });


        if ($('body').find('video').length > 0) {
          $('body').addClass('video');
        }

        $('body').on('click', '.audience-image', function () {
          var title = $(this).find('img').attr('title');
          $('.audiences-header .audience-title .title').fadeOut(500, function () {
            $(this).text(title).fadeIn(500);
          });

          var termID = $(this).attr('data-term-id');
          $('.carousel-inner .item').each(function () {
            var item_term_id = $(this).attr('data-term-id');
            if (item_term_id === termID) {
              var item_no = parseInt($(this).attr('data-number'));
              $('#feature-carousel').carousel(item_no);
            }
          });
          $('.audiences-container .audience-inner-container.active').removeClass('active').addClass('inactive');
          $(this).parents('.audience-inner-container').removeClass('inactive').addClass('active');
        });


        // animation js
        var $animation_elements = $('.animation-element');
        var $window = $(window);
        function check_if_in_view() {
          var window_height = $window.height();
          var window_top_position = $window.scrollTop();
          var window_bottom_position = (window_top_position + window_height - 300);

          $.each($animation_elements, function () {
            var $element = $(this);
            var element_height = $element.outerHeight();
            var element_top_position = $element.offset().top;
            var element_bottom_position = (element_top_position + element_height);

            //check to see if this current container is within viewport

            if ((element_bottom_position >= window_top_position) &&
              (element_top_position <= window_bottom_position)) {
              $element.addClass('in-view');
            }
          });
        }

        $window.on('scroll resize', check_if_in_view);
        $window.trigger('scroll');

        //end of animation js

        $('#mc_mv_EMAIL').attr('placeholder', 'Email');
        $('#mc_mv_FNAME').attr('placeholder', 'First Name');
        $('.mc_interest select option[value=""]').text('Select your Interest');
        $('#mc_signup #mc_signup_form').on('submit', function (e) {
          e.preventDefault();
          var $form = $(this).serialize();
          var valid_email = false;
          var valid_name = false;
          var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          var email = $(this).find('input#mc_mv_EMAIL').val();
          var name = $(this).find('input#mc_mv_FNAME').val();
          var type = $(this).find('select[name="interest"]').val();
          if (email === '') {
            $(this).find('input#mc_mv_EMAIL').parent().find('span.error').text('Please complete your email');
          } else {
            if (!email.match(re)) {
              $(this).find('input#mc_mv_EMAIL').parent().find('span.error').show().text('Please add valid email');
            } else {
              $(this).find('input#mc_mv_EMAIL').parent().find('span.error').hide();
              valid_email = true;
            }
          }
          if (name === '') {
            $(this).find('input#mc_mv_FNAME').parent().find('span.error').show().text('Please complete your name');
          } else {
            $(this).find('input#mc_mv_FNAME').parent().find('span.error').hide();
            valid_name = true;
          }
          if (valid_email === true && valid_name === true) {

            $.ajax({
              type: 'POST',
              url: pw_script_vars.ajaxurl,
              async: false,
              dataType: 'json',
              data: {
                action: 'lead_in_intercom',
                email: email
              },
              success: function (data) {
                if (data.flag) {
                  var src_url = window.location.href;
                  utm_referrals = data.utm_referrals;

                  if (utm_referrals !== null) {
                    var utm_campaign = utm_referrals.utm_campaign;
                    var utm_medium = utm_referrals.utm_medium;
                    var utm_source = utm_referrals.utm_source;
                    src_url = window.location.href + '?utm_source=' + utm_source + '&utm_medium=' + utm_medium + '&utm_campaign=' + utm_campaign;
                  }
                  var thankyou_content = "<div id='thankyou-container' class='in'><h3 class='newsletter-heading'>Thank you!</h3><h4 class='newsletter-sub-heading'>Check your inbox for confirmation.</h4></div>";
                  $('#mc_signup').append(thankyou_content);
                  $('#mc_signup').find('#mc_message .mc_success_msg').hide();
                  $('#mc_signup').find('form').hide();
                  $('.widget_mailchimpsf_widget>h3').hide();
                  $('#mc_signup').find('#thankyou-container').show();
                  analytics.track("email", {
                    "type": "track",
                    "event": 'interested',
                    label: 'newsletter subscribe - Register',
                    category: 'interested',
                    "properties": {
                      "action": "email"
                    }
                  });
                  analytics.identify({
                    'email': email,
                    'name': name,
                    'type': type,
                    'utm': utm_referrals,
                  }, {
                    integrations: {
                      'All': false,
                      MailChimp: true
                    },
                    MailChimp: {
                      "listId": '43c42ea17c',
                      'SOURCEURL': src_url,
                    }
                  });
                } else {
                  $('#mc_signup #mc_signup_form').find('#mc_message').text('There was some problem!');
                }
              },
              error: function (jqXHR, exception) {
                $('#mc_signup #mc_signup_form').find('#mc_message').text('There was some problem!');
              }
            });
          }
          return false;
        });

        $('li.free-trial a').click(function () {
          analytics.track('app referral', {
            "type": "track",
            "event": 'interested',
            label: 'button - location - free trail',
            category: 'interested',
            "properties": {
              "action": 'app referral'
            }
          });
          //            ga('send', 'event', 'Free Trial Signup', 'Free Trial Form Submission', current_page_url);
        });

        $('#cookies-container .accept-cookies, #cookies-container').click(function (e) {
          if (e.target.tagName !== 'A') {
            $.ajax({
              type: 'POST',
              url: pw_script_vars.ajaxurl,
              data: {
                action: 'set_consent_cookie'
              },
              success: function (data) {
                $('#cookies-container').hide();
                $('header').removeClass('cookie-unaccepted');
                $('header').attr('data-cookie-exists', '');
                ga('send', 'event', 'Cookies Disclaimer', 'click close', current_page_url);
                localStorage.setItem('cookie-set', 'set');
                //                        location.reload(true);
              }
            });
          }
        });

        if (window_width > 769) {
          var container_width = $('#campaign-wrapper .container').width();
          var inner_width = window_width - container_width;
          var right_section_width = inner_width / 2;
          //            $('#campaign-wrapper .container').css('width', (container_width+right_section_width));
          //            $('#campaign-wrapper .container.left-version').css('margin-right', '0');
          //            $('#campaign-wrapper .container.right-version').css('margin-left', '0');
        }

        $('form#campaign-form').validate({

          onfocusout: function (element) {
            this.element(element);
          },

          rules: {
            name: {
              required: true,
              minlength: 2
            },
            email: {
              required: true,
              email: true
            }
          },

          messages: {
            name: 'Please enter name',
            email: 'Email is not valid'
          },

          errorElement: "div",
          errorPlacement: function (error, element) {
            element.after(error);
          },
          submitHandler: function (form) {
            var list_id = $('form#campaign-form').find('input[name="list_id"]').val();
            var name = $('form#campaign-form').find('input[name="name"]').val();
            var email = $('form#campaign-form').find('input[name="email"]').val();
            var company = $('form#campaign-form').find('input[name="company"]').val();
            var downloadfile = $('form#campaign-form').find('input[name="download-file"]').val();

            $('form#campaign-form').parents('#campaign-form-container').find('.initial-title').hide();
            $('form#campaign-form').hide();
            $('form#campaign-form').parents('#campaign-form-container').find('.thankyou-title').show();
            $('form#campaign-form').parents('#campaign-form-container').find('#thankyou-button').show();
            var button_text = $(form).find('.form-button').text();
            var page_slug = window.location.pathname;
            page_slug = page_slug.replace(/\//g, '');
            var page_version = 'left';
            if ($('#campaign-wrapper .container').hasClass('right-version')) {
              page_version = 'right';
            }
            if (downloadfile !== "") {
              window.open(document.getElementById('download').href);
            }
            analytics.track('email - download - ' + page_slug, {
              "type": "track",
              label: button_text,
              category: 'interested',
              "properties": {
                "action": 'email - download - ' + page_slug
              }
            });
            analytics.identify(email, {
              'email': email,
              'firstName': name,
              'company': company
            }, {
              integrations: {
                'All': false,
                'MailChimp': true,
              },
              'MailChimp': {
                "listId": list_id
              }
            });
            $.ajax({
              type: 'POST',
              url: pw_script_vars.ajaxurl,
              async: false,
              dataType: 'json',
              data: {
                action: 'lead_in_intercom',
                email: email
              },
              success: function (data) {
                //  window.location.reload();
              }
            });
          }
        });


        jQuery('#campaign-wrapper .form-container #thankyou-button').on('click', function (e) {
          var page_version = 'left';
          if ($('#campaign-wrapper .container').hasClass('right-version')) {
            page_version = 'right';
          }
          analytics.track('site info', {
            "type": "track",
            label: 'return to site - landing ' + page_version,
            category: 'interested',
            "properties": {
              "action": 'site info'
            }
          });
        });

        $('form#mobile-app').on('submit', function (e) {

          e.preventDefault();
          var email = $(this).find('input[name="email"]').val();
          var list_id = $(this).find('input[name="list_id"]').val();
          $.ajax({
            type: 'POST',
            url: pw_script_vars.ajaxurl,
            dataType: 'json',
            data: {
              action: 'lead_in_intercom',
              email: email
            },
            success: function (data) {
              if (data.flag) {
                var src_url = window.location.href;
                var utm_referrals = data.utm_referrals;
                if (utm_referrals !== null) {
                  var utm_campaign = utm_referrals.utm_campaign;
                  var utm_medium = utm_referrals.utm_medium;
                  var utm_source = utm_referrals.utm_source;
                  src_url = window.location.href + '?utm_source=' + utm_source + '&utm_medium=' + utm_medium + '&utm_campaign=' + utm_campaign;
                }
                $('#mobile-app-wrapper').find('.initial-content').hide();
                //                        $("html, body").animate({ scrollTop: 0 }, "slow");

                $('#mobile-app-wrapper').find('.success-content').show();
                analytics.track('email', {
                  "type": "track",
                  label: 'submit form',
                  category: 'interested',
                  "properties": {
                    "action": 'email'
                  }
                });
                analytics.identify({
                  'email': email,
                  'type': type,
                  'utm': utm_referrals,
                }, {
                  integrations: {
                    'All': false,
                    MailChimp: true
                  },
                  'MailChimp': {
                    "listId": list_id,
                    'SOURCEURL': src_url,
                  }
                });
              }
            },
            error: function (jqXHR, exception) {
              $('#mobile-app-wrapper').find('.initial-content').show();
              $('#mobile-app-wrapper').find('.success-content').hide();
            }
          });
          return false;
        });


        $('#mailchimp-form-container form').on('submit', function (e) {
          e.preventDefault();
          var $this = $(this);
          $this.parent().find('p.form-notification').text('');
          var re = /[\w\-]+@[\w\-]+\..+/;
          var email = $(this).find('#email').val();
          var btn_text = $(this).find('button.btn').text();
          analytics.track('button - newsletter-signup', {
            "type": "track",
            label: btn_text,
            category: 'interested',
            "properties": {
              "action": 'button - newsletter-signup'
            }
          });
          if (!email.match(/[\w\-]+@[\w\-]+\..+/)) {
            $this.parent().find('p.form-notification').text('Email is invalid!');
          } else {
            analytics.track('app referral', {
              "type": "track",
              label: btn_text,
              category: 'interested',
              "properties": {
                "action": 'app referral'
              }
            });
            //                analytics.identify({
            //                       'email': email
            //                   },{
            //                    integrations : {
            //                        'All' : false,
            //                    }
            //                });
            $.ajax({
              type: 'POST',
              url: pw_script_vars.ajaxurl,
              dataType: 'json',
              data: {
                action: 'lead_in_intercom_new',
                email: email
              },
              success: function (data) {
                email = email.replace("@", "%40");
                if (data.work_flag === '1') {
                  $('#work_email').val(data.work_email);
                  //                                    $('#registration-modal').modal('show');
                  redirecttoLink("https://app.hibob.com/register?email=" + email, '');
                } else {
                  redirecttoLink("https://app.hibob.com/register?email=" + email, '');
                }
              }
            });
            //$this.parents('.inner-container').addClass('in');
            //$this.find('input').val('');
            //setTimeout(function(){ $this.parents('.inner-container').removeClass('in'); }, 3000);
            //redirecttoLink("https://app.hibob.com/register?email="+email, '_blank');
          }
          return false;
        });

        function getYoutubeId(url) {
          const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
          const match = url.match(regExp);
          return (match && match[2].length === 11)
            ? match[2]
            : null;
        }

        $("#video-modal").on("show.bs.modal", function () {
          var video_src = $("#video-modal").find('.modal-body').attr('data-video-url');
          var videoId = getYoutubeId(video_src);
          analytics.track('Watch', {
            "type": "track",
            label: videoId,
            category: 'Video',
            "properties": {
              "action": 'Watch'
            }
          });
          video_src = video_src + '?autoplay=true';
          $("#video-modal").find('iframe').attr('src', video_src);
        });

        $("#video-modal").on("hide.bs.modal", function () {
          $("#video-modal").find('iframe').attr('src', '');
        });

        $("#video-modal-sm").on("show.bs.modal", function () {
          var video_src = $("#video-modal-sm").find('.modal-body').attr('data-video-url');
          var videoId = getYoutubeId(video_src);
          analytics.track('Watch', {
            "type": "track",
            label: videoId,
            category: 'Video',
            "properties": {
              "action": 'Watch'
            }
          });
          video_src = video_src + '?autoplay=true';
          $("#video-modal-sm").find('iframe').attr('src', video_src);
        });

        $("#video-modal-sm").on("hide.bs.modal", function () {
          $("#video-modal-sm").find('iframe').attr('src', '');
        });

        //Munchkin events on modal open
        $('[data-target="#book-demo-modal"]').each(function() {
          $(this).on('click', function() {
            Munchkin.munchkinFunction('clickLink', {
                'href': '/request-a-demo-modal'
              }
            );
          });
        });
        $('[data-target="#watch-modal"]').each(function() {
          $(this).on('click', function() {
            Munchkin.munchkinFunction('clickLink', {
                'href': '/watch-a-demo-modal'
              }
            );
          });
        });
        $('[data-video-src]').each(function() {
          $(this).on('click', function() {
            var youtubeId = getYoutubeId($(this).attr('data-video-src'));
            Munchkin.munchkinFunction('clickLink', {
                'href': '/play-video-' + youtubeId
              }
            );
          });
        });
        $('[data-target="#video-modal"]').each(function() {
          $(this).on('click', function() {
            var youtubeId = getYoutubeId($('#video-modal').find('[data-video-url]').attr('data-video-url'));
            Munchkin.munchkinFunction('clickLink', {
                'href': '/play-video-' + youtubeId
              }
            );
          });
        });
        
        $(".model-dialog-container").fitVids();

        //resize video
        function sizeTheVideo() {
          // - 1.78 is the aspect ratio of the video
          // - This will work if your video is 1920 x 1080
          // - To find this value divide the video's native width by the height eg 1920/1080 = 1.78
          var aspectRatio = 1.78;
          var newheight2;
          var video = $('#popup-video-resize-js iframe');

          var Windowwidth = $(window).width();
          var WindowHeight = $(window).height();
          if (Windowwidth < 900) {
            if (Windowwidth < WindowHeight) {
              if (Windowwidth < 600) {
                Windowwidth2 = Windowwidth;
                newheight2 = Windowwidth2 / aspectRatio;
              } else {//devices width 600-899
                Windowwidth2 = Windowwidth * 0.8;
                newheight2 = Windowwidth2 / aspectRatio;
              }
            } else { //for rotated state
              newheight2 = WindowHeight - 120;
              Windowwidth2 = newheight2 * aspectRatio;
            }
            video.css({ "width": Windowwidth2 + "px", "height": newheight2 + "px" });
            $(".home-registration-section").show();
          } else if (Windowwidth < 1100) {
            Windowwidth2 = Windowwidth * 0.8;
            newheight2 = Windowwidth2 / aspectRatio;
            video.css({ "width": Windowwidth2 + "px", "height": newheight2 + "px" });
            $(".home-registration-section").show();
          } else {
            videoHeight1 = 900 / aspectRatio;
            //Define the new width and centrally align the iframe
            video.css({ "width": "900px", "height": videoHeight1 + "px" });
            $(".home-registration-section").show();
          }
          //var newWidth = videoHeight*aspectRatio;
        }

        sizeTheVideo();
        $(window).resize(function () {
          sizeTheVideo();
        });
        // end of resize video

        var container_margin = $('#wide-section-wrapper .container').width();
        container_margin = (window_width - container_margin) / 2;
        var right_image_section_width = $('#wide-section-wrapper .right-image-container').width();
        var right_content_width = $('#wide-section-wrapper .section-content-container').width();
        var demo_content_width = right_image_section_width + right_content_width;
        var left_image_width = window_width - demo_content_width - 170 - container_margin + 15;
        $('#wide-section-wrapper .left-image-container').css('width', left_image_width);


        if ($('body').hasClass('single-partner')) {
          var weare = $('.weare');
          weare
            .slick({
              waitForAnimate: true,
              fade: false,
              responsive: [
                {
                  breakpoint: 3000,
                  settings: {
                    speed: 500,
                  }
                },
                {
                  breakpoint: 768,
                  settings: {
                    speed: 700
                  }
                }
              ]
            });
          //.find('li').wrapInner('<span></span>')
          //.on('beforeChange', function(evt,slick,s1, s2) {
          //  var current_slide = weare.find('[data-slick-index=' + s1 + ']');
          //  var next_slide = weare.find('[data-slick-index=' + s2 + ']');
          //  current_slide.removeClass('goin initialview').addClass('goout');
          //  next_slide.removeClass('goout initialview').addClass('goin');

          //})
          //.on('init', function(evt, slick) {
          //  var curr_slide = weare.find('[data-slick-index=0]');
          //  curr_slide.addClass('goin initialview');
          //  weare.find('[data-slick-index=1]').addClass('goout initialview');
          //})
        }
        if (window_width < 768) {

          $('form.app-form button').text('Try bob free');
        }
        
        var quickNav = document.getElementById('quick-navigation');
        if (quickNav) {
          //Generate Navigation Links
          var guickList = quickNav.querySelector('ul');
          
          document.querySelectorAll('.entry-content h2').forEach(function(h2) {
            var id = h2.id || h2.innerText.toLowerCase().replace(/\W/g, '_');
            var text = h2.id.replace(/-/g,' ') || h2.innerText;
            h2.id = id;
            h2.insertAdjacentHTML('beforebegin', '<a name="' + id + '"></a>');
            guickList.insertAdjacentHTML('beforeend', '<li><a href="#' + id + '">' + text + '</a></li>')
          });

          var hashValue = window.location.hash.substr(1);
          if (hashValue !== undefined && hashValue !== '' && jQuery('#' + hashValue).length) {
            jQuery("body, html").animate({
              scrollTop: jQuery('#' + hashValue).offset().top - 100
            }, 1200);
          }

          $('#quick-navigation a').on('click',function(e) {
            e.preventDefault;
            anchorHash = $(this).attr('href');
            var offset = -100; // <-- change the value here
            if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
                if (target.length) {
                    $('html, body').animate({
                        scrollTop: target.offset().top + offset
                    }, 1000);
                    history.pushState(null,null,anchorHash);
                    return false;
                }
              }
          });
        }
      },
      this_is_legacy: function () { // and never executed
        // clone header for stickiness

        $('header.banner .try-bob-free a').attr('data-ga-label', 'header menu');
        $('header.banner').clone().addClass('showonscroll').insertAfter('header.banner');
        $('header.banner.showonscroll .try-bob-free a').attr('data-ga-label', 'sticky header menu');

        if (document.querySelector('body.country-us')) {
          // replace trybobfree buttons with bok a demo
          $BADbutton = $('#footer .promotext button[data-target="#book-demo-modal"]');
          $('a[href="https://app.hibob.com/register"],a[href="https://app.hibob.com/registration"]').each(function () {
            var clone = $BADbutton.clone();
            var galabel = this.getAttribute('data-ga-label');
            if (!galabel) {
              galabel = 'content';
              if ($(this).closest('header.banner').length > 0) {
                galabel = 'header';
              }
              if ($(this).closest('section.hero').length > 0) {
                galabel = 'hero';
              }
            }
            clone.attr('data-ga-label', galabel);
            clone.attr('class', $(this).attr('class'));
            $(this).replaceWith(clone);
          });
          $BADbutton.remove();
        }
        if (document.querySelector('.boborgchart img')) {
          var orgchartloadingsemaphor = false;
          var loadorgiframe = function () {
            if (window.innerWidth < 800) {
              return;
            }
            if (orgchartloadingsemaphor) {
              return;
            }
            orgchartloadingsemaphor = true;
            var src = document.querySelector('.boborgchart img').getAttribute('data-iframe-src');
            var iframe = $('<iframe src="' + src + '" frameborder=0></iframe>');
            iframe.on('load', function () {
              $('.boborgchart').addClass('finished').removeClass('loading showloading');
            });
            $('.boborgchart').addClass('loading').append(iframe);
          };
          loadorgiframe();
          $('.boborgchart').on('mouseenter click touchstart', function (e) {
            if ($(this).hasClass('finished')) {
              return;
            }
            $(this).addClass('showloading');
          });
        }
        $('iframe[data-src]').each(function () {
          $(this).attr('src', $(this).attr('data-src'));
        });

        $('form.app-form').on('submit', function (e) {
          e.preventDefault();
          var $this = $(this);
          var email = $(this).find('input').val();
          if (email === '' || !email.match(/[\w\-]+@[\w\-]+\..+/)) {
            $(this).addClass('has-error').addClass('error');
            $(this).find('input').focus();
            setTimeout(function () { $('form.app-form.has-error').removeClass('has-error'); }, 2000);
          } else {
            $(this).removeClass('error');
            //$(this).find('button[type="submit"] span').text('processing..');
            var label = 'email - header';
            if ($(this).parents('header').length > 0) {
              label = 'email - menu';
            }

            if ($(window).width() < 768) {
              e.preventDefault();
              var $form = $(this).serialize();

              $.ajax({
                type: 'POST',
                url: pw_script_vars.ajaxurl,
                async: false,
                dataType: 'json',
                data: {
                  action: 'submit_mobile_app_form',
                  form: $form
                },
                success: function (data) {
                  analytics.identify({
                    'email': email
                  }, {
                    integrations: {
                      'All': false,
                    }
                  });
                  $(".app-form").hide();
                  $(".app-form-success").show();
                  setTimeout(function () {
                    $(".app-form").show();
                    $(".app-form-success").hide();
                  }, 2000);
                  $('form.app-form button').text('Keep me updated');
                },
                error: function (jqXHR, exception) {
                  $(".app-form").hide();
                  $(".app-form-success").show();
                  setTimeout(function () {
                    $(".app-form").show();
                    $(".app-form-success").hide();
                  }, 2000);
                  $('form.app-form button').text('Keep me updated');
                }
              });
              analytics.track('email', {
                "type": "track",
                label: 'mobile - button header',
                category: 'interested',
                "properties": {
                  "action": 'email'
                }
              });

            } else {
              analytics.track('app referral', {
                "type": "track",
                label: label,
                category: 'interested',
                "properties": {
                  "action": 'app referral'
                }
              });
              $.ajax({
                type: 'POST',
                url: pw_script_vars.ajaxurl,
                dataType: 'json',
                data: {
                  action: 'lead_in_intercom_new',
                  email: email
                },
                success: function (data) {
                  email = email.replace("@", "%40");
                  if (data.work_flag === '1') {
                    $('#work_email').val(data.work_email);
                    //                               $('#registration-modal').modal('show');
                    redirecttoLink("https://app.hibob.com/register?email=" + email, '');
                  } else {
                    redirecttoLink("https://app.hibob.com/register?email=" + email, '');
                  }
                }
              });
              $(this).find('input').val('');
              $(this).find('button[type="submit"] span').text('Free Trial');
              //redirecttoLink("https://app.hibob.com/register?email="+email, '_blank');
              // return true;
            }

          }
          return false;
        });

        if ($('body').hasClass('single-partner')) {
          var weare = $('.weare');
          weare
            .slick({
              waitForAnimate: true,
              fade: false,
              responsive: [
                {
                  breakpoint: 3000,
                  settings: {
                    speed: 500,
                  }
                },
                {
                  breakpoint: 768,
                  settings: {
                    speed: 700
                  }
                }
              ]
            });
        }
        if (window_width < 768) {

          $('form.app-form button').text('Try bob free');
        }
      },
      finalize: function () {
        function setCookie(name, value, options = {}) {

          options = {
            path: '/'
          };

          if (options.expires instanceof Date) {
            options.expires = options.expires.toUTCString();
          }

          let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

          for (let optionKey in options) {
            updatedCookie += "; " + optionKey;
            let optionValue = options[optionKey];
            if (optionValue !== true) {
              updatedCookie += "=" + optionValue;
            }
          }

          document.cookie = updatedCookie;
        }

        // clone header for stickiness
        $('header.banner .try-bob-free a').attr('data-ga-label', 'header menu');
        $('header.banner').clone().addClass('showonscroll').insertAfter('header.banner');
        $('header.banner.showonscroll .try-bob-free a').attr('data-ga-label', 'sticky header menu');

        //add lity popup for all images
        $(document).on('click', '[data-lightbox]', lity);

        var requestDemoCookie = getCookie('request_demo_variation');
        if ( requestDemoCookie === undefined || requestDemoCookie == null || requestDemoCookie.length <= 0 ) {
          var variant = Math.random();
          if ( variant < 0.5 ) {
            variant = Math.floor(variant)
          }
          else {
            variant = Math.ceil(variant)
          }
          requestDemoCookie = variant;
          setCookie('request_demo_variation', requestDemoCookie);
        }
        if ( requestDemoCookie ) {
          var buttMenuDemo = $('#menu-main-menu .try-bob-free button');
          buttMenuDemo.attr('data-toggle', '');
          buttMenuDemo.attr('onclick', 'window.location.href="https://www.hibob.com/book-a-demo/";');
        }

        $('.recommendations-list a')
          .on('click', function () {
            analytics.track('click', {
              category: 'interaction_ad_text',
              action:   'click',
              label:    $(this).text()
            });
          });

        //start mark shortcode
        function isScrolledIntoView($elem, $window) {
            var docViewTop = $window.scrollTop();
            var docViewBottom = docViewTop + $window.height();
            var elemTop = $elem.offset().top;
            var elemBottom = elemTop + $elem.height();
            return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
        }

        function mark(keyword,classTrigger) {
          // Determine selected options
          var options = {
            "each": function(element) {
              setTimeout(function() { jQuery(element).addClass("animate"); }, 500);
            }
          };
          options['separateWordSearch'] = false;
          options['element'] = 'marker';
          //console.log('mark keyword: ' + keyword);
          jQuery("."+classTrigger).mark(keyword, options);
        };

        var markKeyword=[];
        var markerClass = [];
        var i =0;
        jQuery(".marker").each(function(){
            markKeyword[i] = jQuery(this).text();
            jQuery(this).addClass("marker"+i);
            markerClass[i]= "marker"+i;
            i++;
        });
        //console.log( markKeyword );

        var keyword = markKeyword;
        var html_trigger = markerClass;
            jQuery(document).on("scroll", function () {
            var $window = jQuery(window);
            // Read the keyword
            jQuery.each(html_trigger, function(index, value){
                var elem = jQuery('.'+value);
                if (isScrolledIntoView(elem, $window)) {
                    //console.log(keyword[index]);
                    mark(keyword[index],html_trigger);
                    if (index > -1) {
                        keyword.splice(index, 1);
                        html_trigger.splice(index, 1);
                    }
                }
            });
        });
        //end mark shortcode

        //lobby ajax
        if ($('#main').hasClass('article-list')) {
            jQuery(function($){
                var canBeLoaded = true, // this param allows to initiate the AJAX call only if necessary
                    bottomOffset = 2000; // the distance (in px) from the page bottom when you want to load more posts
                $(window).scroll(function(){
                    var data = {
                        'action': 'loadmore',
                        'query': lobby_ajax_query.posts,
                        'page' : lobby_ajax_query.current_page,
                        'posts_per_page_ajax' : lobby_ajax_query.posts_per_page_ajax,
                        'archive_rsrcv2' : lobby_ajax_query.archive_rsrcv2,
                        'blog' : lobby_ajax_query.blog
                    };
                    if( $(document).scrollTop() > ( $(document).height() - bottomOffset ) && canBeLoaded == true && lobby_ajax_query.current_page <= lobby_ajax_query.max_page ){
                        $.ajax({
                            url : lobby_ajax_query.ajaxurl,
                            data:data,
                            type:'POST',
                            beforeSend: function( xhr ){
                                // you can also add your own preloader here
                                // you see, the AJAX call is in process, we shouldn't run it again until complete
                                canBeLoaded = false;
                            },
                            success:function(data){
                                if( data ) {
                                    $('.site-main').find('a:last-of-type').after( data ); // where to insert posts
                                    canBeLoaded = true; // the ajax is completed, now we can run it again
                                    lobby_ajax_query.current_page++;
                                }
                            }
                        });
                    }
                });
            });
        }

        $('.social-wrap-desktop .LoveCount').bind('DOMSubtreeModified', function(){
          $('.social-wrap-mobile .LoveCount').text($(this).text());
        });
        
        //Script for drift chat
        (function() {
          var drift_selector = "a[href*='#talktous']";
          function ready(fn) {
            if (document.readyState != 'loading') {
              fn();
            } else if (document.addEventListener) {
              document.addEventListener('DOMContentLoaded', fn);
            } else {
              document.attachEvent('onreadystatechange', function() {
                if (document.readyState != 'loading')
                  fn();
              });
            }
          }
          function forEachElement(selector, fn) {
            var elements = document.querySelectorAll(selector);
            for (var i = 0; i < elements.length; i++)
              fn(elements[i], i);
          }
          function openChat(driftApi, event) {
            event.preventDefault();
            driftApi.widget.openChat();
            return false;
          }
          function openSidebar(driftApi, event) {
            event.preventDefault();
            driftApi.sidebar.open();
            return false;
          }
          function openTalkToUsSidebar(driftApi, event) {
            event.preventDefault();
            location.hash = 'talktous';
            driftApi.sidebar.open();
            return false;
          }
          function DrifOpenTalkToUsSidebar(){
            if(typeof drift !== "undefined"){
              drift.on('ready', function(api) {
                      var handleClick = openTalkToUsSidebar.bind(this, api);
                      forEachElement(drift_selector, function(el) {
                        el.addEventListener('click', handleClick);
                      });
              });
            } else {
                setTimeout(DrifOpenTalkToUsSidebar, 500);
            }
          }
          ready(function() {
            DrifOpenTalkToUsSidebar();
          });
        })();

        //start mobile menu lobby tags
        /*
         * https://github.com/mattkersley/Responsive-Menu
         */
        var menu_object = {"nav_text":"Topics"};
        if( typeof lobby_ajax_query !== 'undefined' ) {
            if ( lobby_ajax_query.archive_rsrcv2 ) {
                var menu_object = {"nav_text":"Filter Resources"};
            }
        }
        ;(function(a){var b=0;a.fn.mobileMenu=function(c){function e(a){return a.is("ul, ol")}function f(){return a(window).width()<d.switchWidth}function g(c){if(c.attr("id")){return a("#mobileMenu_"+c.attr("id")).length>0}else{b++;c.attr("id","mm"+b);return a("#mobileMenu_mm"+b).length>0}}function h(a){if(a.val()!==null){document.location.href=a.val()}}function j(b){b.css("display","none");a("#mobileMenu_"+b.attr("id")).show()}function k(b){b.css("display","");a("#mobileMenu_"+b.attr("id")).hide()}function l(b){if(e(b)){var c='<div class="td_mobile_menu_wrap"><select id="mobileMenu_'+b.attr("id")+'" class="mobileMenu">';c+='<option value="">'+d.topOptionText+"</option>";b.find("li").each(function(){var b="";var e=a(this).parents("ul, ol").length;for(i=1;i<e;i++){b+=d.indentString}var f=a(this).find("a:first-child").attr("href");var g=b+a(this).clone().children("ul, ol").remove().end().text();c+='<option value="'+f+'">'+g+"</option>"});c+="</select></div>";b.parent().append(c);a("#mobileMenu_"+b.attr("id")).change(function(){h(a(this))});j(b)}else{alert("mobileMenu will only work with UL or OL elements!")}}function m(a){if(f()&&!g(a)){l(a)}else if(f()&&g(a)){j(a)}else if(!f()&&g(a)){k(a)}}var d={switchWidth:768,topOptionText:menu_object.nav_text,indentString:"-"};return this.each(function(){if(c){a.extend(d,c)}var b=a(this);a(window).resize(function(){m(b)});m(b)})}})(jQuery);

        jQuery(document).ready( function() {
            jQuery('#top-menu ul.menu').mobileMenu({
                switchWidth: 1300,
                combine: false,
                });
            jQuery('#top-menu div.menu ul').mobileMenu({
                switchWidth: 1300,
                combine: false,
                });
        });

        jQuery(document).ready( function() {
            jQuery('#site-navigation ul.menu').mobileMenu({
                switchWidth: 767,
                combine: false,
                });
            jQuery('#site-navigation div.menu ul').mobileMenu({
                switchWidth: 767,
                combine: false,
                });
        });
        //end mobile menu

        function fix_demo_button_ga_label(button) {
          var galabel = button.getAttribute('data-ga-label');
          if (!galabel) {
            galabel = 'content';
            if ($(button).closest('header.banner').length > 0) {
              galabel = 'header';
            }
            if ($(button).closest('section.hero').length > 0) {
              galabel = 'hero';
            }
          }
          return galabel;
        }

        $('[data-ga-action]').each(function (elm) {
          $(this).attr('data-ga-label', fix_demo_button_ga_label(this));
        });
        if (0 && document.querySelector('body.country-us')) {
          // replace trybobfree buttons with book a demo button clone from footer
          $BADbutton = $('#footer .promotext button[data-target="#book-demo-modal"]');
          $('a[href="https://app.hibob.com/register"],a[href="https://app.hibob.com/registration"]').each(function () {
            var clone = $BADbutton.clone();
            var galabel = fix_demo_button_ga_label(this);
            clone.attr('data-ga-label', galabel);
            clone.attr('class', $(this).attr('class'));
            $(this).replaceWith(clone);
          })
          $BADbutton.remove();
        }

        if (document.querySelector('.boborgchart img')) {
          var orgchartloadingsemaphor = false;
          var loadorgiframe = function () {
            if (window.innerWidth < 800) {
              return;
            }
            if (orgchartloadingsemaphor) {
              return;
            }
            orgchartloadingsemaphor = true;
            var src = document.querySelector('.boborgchart img').getAttribute('data-iframe-src');
            var iframe = $('<iframe src="' + src + '" frameborder=0></iframe>');
            iframe.on('load', function () {
              $('.boborgchart').addClass('finished').removeClass('loading showloading');
            });
            $('.boborgchart').addClass('loading').append(iframe);
          };
          loadorgiframe();
          $('.boborgchart').on('mouseenter click touchstart', function (e) {
            if ($(this).hasClass('finished')) {
              return;
            }
            $(this).addClass('showloading');
          });
        }
        $('iframe[data-src]').each(function () {
          $(this).attr('src', $(this).attr('data-src'));
        });


        if (document.querySelector('div.vacancies-list')) {
          $('div.vacancies-list h4').wrapAll('<div class=titles></div>');
          $('div.vacancies-list ul').wrapAll('<div class=lists></div>');
          $('div.vacancies-list').on('click', 'h4', function () {
            $(this).siblings().removeClass('active');
            $(this).toggleClass('active')
            $(this).closest('div.vacancies-list').find('ul').removeClass('active')
            $(this).closest('div.vacancies-list').find('ul:eq(' + $(this).index() + ')').toggleClass('active')
          });
          var whereami = 'london';
          if ($('body').hasClass('country-us')) whereami = 'new york';
          if ($('body').hasClass('country-il')) whereami = 'tel aviv';
          $('div.vacancies-list h4[data-where="' + whereami + '"]').trigger('click');
        }
        if (document.querySelector('.instagram-feed')) {
          document.body.insertAdjacentHTML('beforeend', '<div class="modal fade" id="show-instagram-modal" tabindex="-1" role="dialog"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-body"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><svg><use xlink:href="#x-popup"></use></svg></button><blockquote class="instagram-media" data-instgrm-captioned data-instgrm-permalink="" data-instgrm-version="12"></blockquote></div></div></div></div>');
          $('#show-instagram-modal').on('hide.bs.modal', function () {
            // restore the blockquote
            $(this).find('iframe').replaceWith('<blockquote class="instagram-media" data-instgrm-captioned data-instgrm-permalink="" data-instgrm-version="12"></blockquote>')
          });
          $.getScript('//www.instagram.com/embed.js');
          $('.instagram-feed .wrapper').each(function () {
            var wrapper = this;
            $.post(pw_script_vars.ajaxurl, { action: 'fetch_instagram', hash: $(this).attr('data-hash') }, function (html) {
              $(wrapper).html(html);
            });
          });
          $('body').on('click', '.instagram-feed a', function (e) {
            e.preventDefault();
            var insthandler = $('blockquote.instagram-media');
            insthandler.attr('data-instgrm-permalink', this.href);
            instgrm.Embeds.process()
            insthandler.closest('.modal').modal('show')
            return false;
          })
        }

        if ($('video.seethru.seethru-video-original').length > 0) {
          seeThru.attach($);
          $('video.seethru.seethru-video-original').seeThru({ end: 'rewind' });
          $('video.seethru.seethru-video-original').each(function () {
            this.play()
          });
        }
      }
    },
    /* 'single_vacancy': {
       'init': function() {

         function find_place_for_apply_form() {
           var form = $('#form_apply_to_job').parent();
           if ($(window).width() <= '991'){
             $(document).find('#form-apply-mobile').append(form);
           } else {
             $(document).find('#form-apply-desktop').append(form);
           }
         }
         $(window).on('load resize',find_place_for_apply_form);

         $(document).on('change', '[type="file"]', function(e) {
           if (this.files.length===0) return;

           var $label = $(this).closest('.frm_form_field').find('label');
           $label.text(this.files[0].name);
         });
       }
     },*/
    'page_template_template_thank_you': {
      'init': function () {
        $('.video-wrap .play').on('click', function () {
          $('#video-modal .modal-body').attr('data-video-url', $(this).attr('data-video-src'));
          $("#video-modal").modal('show');
        });
      }
    },
    'page_template_template_free_mason': {
      'init': function () {
        $('.testimonial .play').on('click', function () {
          $('#video-modal .modal-body').attr('data-video-url', $(this).attr('data-video-src'));
          $("#video-modal").modal('show');
        });

        $('.vacancy-testimonial .testimonial-wrap').slick({
          adaptiveHeight: true,
          draggable: false,
          slidesToShow: 1,
          dots: true,
          arrows: false,
          speed: 1000,
        });

        //dynamic-lp
        $('.our-customers .testimonial-wrap').slick({
          slidesToShow: 3,
          responsive: [
            {
              breakpoint: 769,
              settings: {
                adaptiveHeight: true,
                slidesToShow: 1,
                arrows: true
              }
            }
          ]
        });

        //leadership (about)
        $('.bobboard.leadership .person').click(function(){
            $('.bobboard.leadership .person.selected').removeClass('selected');
            $(this).addClass('selected');
            bioCounter = $(this).attr('data-counter');
            $('#bio-wrapper .figure-bio').removeClass('selected');
            $('#bio-wrapper .figure-bio[data-counter="'+bioCounter+'"]').addClass('selected');
        });

      },
      'finalize' : function () {
        if ($(window).width() < 768){
          $('.not-included').remove();
          $(document).ready(function(){
            $('section.feature-items-wrap').slick({
                  autoplay: true
                });
          });
        };

        $('.scroll-to-form').click(function (e) {
          e.preventDefault();
          if ($(window).width() > 767){
            scrollOffset = $('#form-lp .mkto-wrapper').offset().top - 100;
          }
          else {
            scrollOffset = $('#form-lp .mkto-wrapper').offset().top - 25;
          }
          scrollOffset = scrollOffset;
          $('html, body').animate({
            scrollTop: scrollOffset
          }, 400);
        });
        
        $('.content-template-2020 .cta-button').click(function (e) {
          e.preventDefault();
          if ($(window).width() > 767){
            scrollOffset = $(this.hash).offset().top - 65;
          }
          else {
            scrollOffset = $(this.hash).offset().top - 15;
          }
          scrollOffset = scrollOffset;
          $('html, body').animate({
            scrollTop: scrollOffset
          }, 400);
        });
        
        $('.hero.vacancy-index a').click(function (e) {
          e.preventDefault();
          if ($(window).width() > 767){
            scrollOffset = $(this.hash).offset().top - 65;
          }
          else {
            scrollOffset = $(this.hash).offset().top - 15;
          }
          scrollOffset = scrollOffset;
          $('html, body').animate({
            scrollTop: scrollOffset
          }, 400);
        });
      }
    },
    'single_features': {
      'init': function () {
        var hashValue = window.location.hash.substr(1);
        if (hashValue !== undefined && hashValue !== '' && jQuery('#' + hashValue).length) {
            if ($(window).width() > 767){
              $offset = parseInt( jQuery( '#' + hashValue ).data( 'offsetDesk' ) );
            }
            else {
              $offset = parseInt( jQuery( '#' + hashValue ).data( 'offsetMobile' ) );
            }
            jQuery("body, html").animate({
                scrollTop: jQuery('#' + hashValue).offset().top + $offset
            }, 2000);
            setTimeout(function () {
                jQuery("body, html").animate({
                    scrollTop: jQuery('#' + hashValue).offset().top + $offset
                }, 2000);
            }, 2000);
        }
        
        $('.tools-wrap a').click(function (e) {
          e.preventDefault();
          var value = $(this).prop("hash").substr(1);
        $offset = parseInt( jQuery( '#' + value ).data( 'offsetDesk' ) );
        jQuery("body, html").animate({
            scrollTop: jQuery('#' + value).offset().top + $offset
        }, 400);
        });

        $('.morefeatures').slick({
          slidesToShow: 1,
          responsive: [
            {
              breakpoint: 4000,
              settings: {
                slidesToShow: 3,
                slidesToSlide: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                adaptiveHeight: true,
                slidesToShow: 1
              }
            }
          ]
        });
        if ($('figure.hero .header-title').width() >= window.innerWidth) {
          $('figure.hero .header-title').addClass('smaller-font');
        }
      }
    },
    'page_template_page_brochure': {
        'finalize' : function () {
            $(document).ready(function(){
              $('.icons-container.mobile').slick({
                    autoplay: true
                  });
            });
        }
    },
    'single_one_pager': {
        'finalize' : function () {
            $(document).ready(function(){
              $('.icons-container.mobile').slick({
                    autoplay: true
                  });
            });
        }
    },
    'page_template_page_inner_resource': {
        'finalize' : function () {
          $('.scroll-to-form').click(function (e) {
            e.preventDefault();
            scrollOffset = $('.resource-form-wrapper').offset().top;
            scrollOffset = scrollOffset - 100;
            $('html, body').animate({
              scrollTop: scrollOffset
            }, 400);
          });
        }
    },
    'page_template_page_hibob_vs_x': {
        'finalize' : function () {
            var accordion_new = (function () {
                var $accordion_new = $('.js-accordion');
                var $accordion_header = $accordion_new.find('.js-accordion-header');
                var $accordion_item = $('.js-accordion-item');
                // default settings
                var settings = {
                    // animation speed
                    speed: 300,
                    // close all other accordion items if true
                    oneOpen: false
                };
                return {
                    // pass configurable object literal
                    init: function ($settings) {
                        $accordion_header.on('click', function () {
                            accordion_new.toggle($(this));
                        });
                        $.extend(settings, $settings);
                        // ensure only one accordion is active if oneOpen is true
                        if (settings.oneOpen && $('.js-accordion-item.active').length > 1) {
                            $('.js-accordion-item.active:not(:first)').removeClass('active');
                        }
                        // reveal the active accordion bodies
                        $('.js-accordion-item.active').find('> .js-accordion-body').show();
                    },
                    toggle: function ($this) {
                        if (settings.oneOpen && $this[0] != $this.closest('.js-accordion').find('> .js-accordion-item.active > .js-accordion-header')[0]) {
                            $this.closest('.js-accordion')
                                .find('> .js-accordion-item')
                                .removeClass('active')
                                .find('.js-accordion-body')
                                .slideUp()
                        }
                        // show/hide the clicked accordion item
                        $this.closest('.js-accordion-item').toggleClass('active');
                        $this.next().stop().slideToggle(settings.speed);
                        if ($(window).width() > 767){
                          $offset = -50;
                        }
                        else {
                          $offset = 0;
                        }
                        setTimeout(function () {
                            jQuery("body, html").animate({
                                scrollTop: jQuery($this).offset().top + $offset
                            }, 300);
                        }, 400);
                    }
                }
            })();
            jQuery(function ($) {
                accordion_new.init({
                    speed: 300,
                    oneOpen: true
                });
            });
        }
    },
    'page_template_template_faq': {
        'finalize' : function () {
            var accordion_new = (function () {
                var $accordion_new = $('.js-accordion');
                var $accordion_header = $accordion_new.find('.js-accordion-header');
                var $accordion_item = $('.js-accordion-item');
                // default settings
                var settings = {
                    // animation speed
                    speed: 300,
                    // close all other accordion items if true
                    oneOpen: false
                };
                return {
                    // pass configurable object literal
                    init: function ($settings) {
                        $accordion_header.on('click', function () {
                            accordion_new.toggle($(this));
                        });
                        $.extend(settings, $settings);
                        // ensure only one accordion is active if oneOpen is true
                        if (settings.oneOpen && $('.js-accordion-item.active').length > 1) {
                            $('.js-accordion-item.active:not(:first)').removeClass('active');
                        }
                        // reveal the active accordion bodies
                        $('.js-accordion-item.active').find('> .js-accordion-body').show();
                    },
                    toggle: function ($this) {
                        if (settings.oneOpen && $this[0] != $this.closest('.js-accordion').find('> .js-accordion-item.active > .js-accordion-header')[0]) {
                            $this.closest('.js-accordion')
                                .find('> .js-accordion-item')
                                .removeClass('active')
                                .find('.js-accordion-body')
                                .slideUp()
                        }
                        // show/hide the clicked accordion item
                        $this.closest('.js-accordion-item').toggleClass('active');
                        $this.next().stop().slideToggle(settings.speed);
                        if ($(window).width() > 767){
                          $offset = -50;
                        }
                        else {
                          $offset = 0;
                        }
                        setTimeout(function () {
                            jQuery("body, html").animate({
                                scrollTop: jQuery($this).offset().top + $offset
                            }, 300);
                        }, 400);
                    }
                }
            })();
            jQuery(function ($) {
                accordion_new.init({
                    speed: 300,
                    oneOpen: true
                });
            });
        }
    },
    'archive': {
      'init': function () {
        if ($('body').hasClass('post-type-archive-casestudy')) {

          //shareSelectedText('.post-type-archive-casestudy article', {
          //  twitterUsername: 'hibobhr',
          //  buttons: [ 'twitter' ]
          //});
          $('article .quotes .width').slick({
            adaptiveHeight: true,
            draggable: false,
          });
        }
      },
    },
    'single_partner': {
      'init': function () {
         $('#vid-play-wrap').on('click', function () {
               console.log('open video modal');
               $('#video-modal .modal-body').attr('data-video-url', $(this).attr('data-video-src'));
               $("#video-modal").modal('show');
         });
      }
    },
    'single_guides': {
       'init': function () {
            //Generate Navigation Links
              document.querySelectorAll('article h2').forEach(function(h2) {
                var id = h2.id || h2.innerText.toLowerCase().replace(/\W/g, '_')
                var text = h2.id.replace(/-/g,' ') || h2.innerText
                h2.id = id
                h2.insertAdjacentHTML('beforebegin', '<a name="' + id + '"></a>')
                document.querySelector('section.navigation nav').insertAdjacentHTML('beforeend', '<a href="#' + id + '">' + text + '</a>')
              });

             let link = $('.navigation .anchors a');

             var hashValue = window.location.hash.substr(1);
              if (hashValue !== undefined && hashValue !== '' && jQuery('#' + hashValue).length) {
                jQuery("body, html").animate({
                  scrollTop: jQuery('#' + hashValue).offset().top - 100
                }, 1200);
                $('a[href="#'+hashValue+'"]').addClass('active');
              } else {
                $(link).first().addClass('active');
              }

            $(link).click(function () {
              $(this).addClass('active');
              $(link).not($(this)).removeClass('active');
            });

            $('.navigation .anchors a').on('click',function(e) {
              e.preventDefault;
              anchorHash = $(this).attr('href');
              var offset = -100; // <-- change the value here
              if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
                  var target = $(this.hash);
                  target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
                  if (target.length) {
                      $('html, body').animate({
                          scrollTop: target.offset().top + offset
                      }, 1000);
                      history.pushState(null,null,anchorHash);
                      return false;
                  }
                }
           });
      }
    },
    'page_template_page_pdf_2_html': {
       'init': function () {
            //Generate Navigation Links
              document.querySelectorAll('article h2').forEach(function(h2) {
                var id = h2.id || h2.innerText.toLowerCase().replace(/\W/g, '_')
                var text = h2.id.replace(/-/g,' ') || h2.innerText
                h2.id = id
                h2.insertAdjacentHTML('beforebegin', '<a name="' + id + '"></a>')
                document.querySelector('section.navigation nav').insertAdjacentHTML('beforeend', '<a href="#' + id + '">' + text + '</a>')
              });

             let link = $('.navigation .anchors a');

             var hashValue = window.location.hash.substr(1);
              if (hashValue !== undefined && hashValue !== '' && jQuery('#' + hashValue).length) {
                jQuery("body, html").animate({
                  scrollTop: jQuery('#' + hashValue).offset().top - 100
                }, 1200);
                $('a[href="#'+hashValue+'"]').addClass('active');
              } else {
                $(link).first().addClass('active');
              }

            $(link).click(function () {
              $(this).addClass('active');
              $(link).not($(this)).removeClass('active');
            });

            $('.navigation .anchors a').on('click',function(e) {
              e.preventDefault;
              anchorHash = $(this).attr('href');
              var offset = -100; // <-- change the value here
              if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
                  var target = $(this.hash);
                  target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
                  if (target.length) {
                      $('html, body').animate({
                          scrollTop: target.offset().top + offset
                      }, 1000);
                      history.pushState(null,null,anchorHash);
                      return false;
                  }
                }
           });
      }
    },
    'page_template_template_watch_video_2021': {
      'init': function () {
        $('video + svg').on('click', () => {
          $('.watch-demo-form-wrapper input.mktoRequired, .watch-demo-form-wrapper select.mktoRequired').each(function(e) {
            if ($(this).val().length == 0) {
              $(this).addClass('mktoInvalid');
            }
          });
        });
      }
    },
    'integration': {
      init: function () {
        $('section.intcat .list').each(function () {
          if ($(this).find('.int').length < 2) {
            return;
          }
          $(this)
            .on('init', function (slick) {
              var ww = $(slick.target).find('.envelope:eq(0)').width();
              $('.maincontent')[0].style.setProperty('--envelopewidth', ww + 'px');
            })
            .slick({
              responsive: [
                {
                  breakpoint: 5000,
                  settings: 'unslick'
                },
                {
                  breakpoint: 768,
                  settings: {
                    slide: '.int',
                    infinite: false,
                    dots: false,
                    arrows: false,
                    slidesToShow: 1.2,
                    slidesToSlide: 1.2
                  }
                }
              ]
            });
        });
      }
    },
    'pricing_plans': {
      init: function () {
        $('#pricing-image-container')
          .on('click', '.phone a', function () {
            analytics.track('click', {
              label: 'prices page phone',
              category: 'interaction'
            });
          });
      },
      finalize: function () {
        $('#field_utm_referrals').val(getCookie('utm_referrals_cookie'));
      }
    },
    'single': {
      init: function () {
        $('.section-main-container-section .section-main-row').each(function () {
          if (jQuery(this).hasClass('feature-sub-section') && !jQuery(this).next().hasClass('feature-sub-section')) {
            jQuery(this).find('.section-container').css('border-bottom', 'none');
          }
        });
      }
    }
  };

  function set_up_pricing_form_integration($) {
    $('.pricingpageform [id^=field_utm_referrals]').val(getCookie('utm_referrals_cookie'));
    $('.pricingpageform')
      .on('submit', function () {
        var galabel, sfleadsource;
        if ($(this).attr('id') == 'form_pricingform') {
          galabel = 'pricing form'; // legacy
          sfleadsource = 'Contacted us';
        } else {
          galabel = sfleadsource = $(this).attr('id');
        }

        var agreefield = $(this).find('[id^=termsagree]');
        if (agreefield.length > 0 && !agreefield.get(0).checked) {
          analytics.track('form error', {
            label: galabel,
            category: 'interaction'
          });
          return;
        }

        var campaign = $(this).find('[id^=field_utm_referrals]').val().split(/[,+]/);
        var email = $(this).find('[id^=field_email]').val();
        if (email === '' || !email.match(/[\w\-]+@[\w\-]+\..+/)) {
          return;
        }
        var params = {
          "name": $(this).find('[id^=field_name]').val(),
          "email": email,
          "phone": $(this).find('[id^=field_phone]').val(),
          "company": $(this).find('[id^=field_companyname]').val(),
          "Description": $(this).find('[id^=field_comments]').val(),
          "Campaign_Name": campaign[campaign.indexOf('utm_campaign') + 1],
          "Campaign_Source": campaign[campaign.indexOf('utm_source') + 1],
          "Campaign_Medium": campaign[campaign.indexOf('utm_medium') + 1],
          "Lead Source": sfleadsource,
          "Additional_Source_Information": 'https://hibob.com' + location.pathname,
        };
        var countryname = $(this).find('[id^=field_countryname]').val();
        if (countryname) {
          params.country = countryname;
        }
        var employees = $(this).find('[id^=field_companyemployees]');
        if (employees.length > 0) {
          params.NumberOfEmployees = params.Number_of_EE_s = parseInt(employees.val().replace(/[^\d-]/, '').split('-').slice(-1)[0]);
        }

        if ($(this).attr('id') === 'form_partnership') {
          params.PartnerSource = "Bob Partner page";
          var partnertype = $(this).find('[id^=field_partnertype] option:selected').text();
          params.Additional_Source_Information = partnertype;
        }

        analytics.identify(email, params, {
          integrations: {
            All: true,
            Salesforce: true
          }
        });
        analytics.track('submit', {
          label: galabel,
          category: 'interaction'
        }, {
          integrations: {
            All: true,
          }
        });
      });
  }
  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);


  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    var headerheight = $('header.banner').outerHeight();
    var weare = document.querySelector('.weare.slick-slider');
    var window_width = $(window).width();
    if (weare && isInViewport(weare)) {
      weare.classList.add('inviewport');
    }
    if (scroll > headerheight) {
      $('header').addClass('sticky').removeClass('cookie-unaccepted');
      if (window_width > 767) {
        $('body.page-template-page-pdf-2-html .navigation').addClass('sticky');
        $('body.guides-template-default .navigation').addClass('sticky');
      }
    } else {
      $('header').removeClass('sticky');
      $('body.page-template-page-pdf-2-html .navigation').removeClass('sticky');
      $('body.guides-template-default .navigation').removeClass('sticky');
      var cookie_exists = $('header').attr('data-cookie-exists');
      if (cookie_exists === 'cookie-unaccepted') {
        $('header').addClass('cookie-unaccepted');
      }
    }
    if ($('.single-post, .blog, .category, body.single-glossary').length > 0 && scroll > 400) {
      $('body').addClass('scroll-topbanner');
    } else {
      $('body').removeClass('scroll-topbanner');
    }
  });


  function register($form) {
    $.ajax({
      type: $form.attr('method'),
      url: $form.attr('action'),
      data: $form.serialize(),
      cache: false,
      dataType: 'json',
      contentType: "application/json; charset=utf-8",
      error: function (err) { $('#notification_container').html('<span class="alert">Could not connect to server. Please try again later.</span>'); },
      success: function (data) {
        var message = '';
        if (data.result !== "success") {
          message = data.msg.substring(4);
          $('#thankyou-container').show();
          $('#newsletter-container .form-section').hide();
        } else {
          message = data.msg;
          $('#newsletter-container .form-section').hide();
          $('#thankyou-container').append('<span class="success">' + message + '</span>').show();
        }
      }
    });
  }

  var $form = $('#mc-embedded-subscribe-form');

  $('#mc-embedded-subscribe').on('click', function (event) {
    event.preventDefault();
    var email = $('#mce-EMAIL').val();

    if (email === '' || !email.match(/[\w\-]+@[\w\-]+\..+/)) {
      alert('Please add a valid email');
      return false;
    } else {
      register($form);
    }
  });
  // for pricing - contact .
  $("#contact_us_btn, .contact_us_btn").click(function () {
    $(".contact-section").fadeIn(3000).removeClass("hidden");
    $(".banner-section").fadeOut(3000).addClass("hidden");
    $(".page-content-container").removeClass("contact-form-submitted");
    $(".page-content-container").removeClass("col-md-offset-3");
    $(".page-content-container").removeClass("col-md-6");
    $(".page-content-container").addClass("col-md-9");
    $(".page-content-container").addClass("col-md-offset-1");
    $(".page-content-container .header-container").show();
    $(".page-content-container .form-container").attr("style", "");
    $(".page-content-container .form-container .frm_message").hide();
    $(".page-content-container .form-container .frm_form_fields ").show();
  });
  $("#back_arrow_contact_pri_btn").click(function () {
    $(".banner-section").fadeIn(3000).removeClass("hidden");
    $(".contact-section").fadeOut(3000).addClass("hidden");
  });
  var window_width_menu = $(window).width();
  if (window_width_menu > 768) {
    jQuery('#menu-mobile-menu>li').click(function () {
      if (jQuery(this).hasClass("active_sub_menu")) {
        jQuery(this).removeClass("active_sub_menu");
        jQuery(this).find('.sub-menu').hide();
      } else {
        jQuery(this).addClass("active_sub_menu");
        jQuery(this).find('.sub-menu').show();
      }

    });
  }
  $("#password-reg").mouseenter(function () {
    $(".password_info_container").show();
  });
  $("#password-reg").mouseout(function () {
    $(".password_info_container").hide();
  });
  $("#companyName").focusout(function () {
    var flag = 0;
    var companyName = $("#companyName").val();
    if (companyName.trim() == '') {
      $(".companyname-error").attr("data-original-title", 'Missing Data');
      $(".companyname-error").removeClass("hidden");
      $(".company-name-containers").removeClass("company-name-container");
      flag = 1;
    } else {
      $(".companyname-error").attr("data-original-title", 'Missing Data');
      $(".companyname-error").addClass("hidden");
      $(".company-name-containers").removeClass("company-name-container");
    }
    if (flag == 1) {
      return false;
    } else {
      jQuery.ajax({
        type: 'POST',
        dataType: 'json',
        url: pw_script_vars.ajaxurl,
        data: {
          action: 'chk_comapny_name',
          companyName: companyName
        },
        success: function (result) {
          if (result.error_company === '1') {
            //$(".compamy_error").html(result.error_company_msg);
            $(".companyname-error").removeClass("hidden");
            $(".companyname-error").attr("data-original-title", result.error_company_msg);
            $(".company-name-containers").addClass("company-name-container");
          } else {
            //$(".compamy_error").html('');
            $(".companyname-error").addClass("hidden");
            $(".companyname-error").attr("data-original-title", 'Missing Data');
            $(".company-name-containers").removeClass("company-name-container");
          }
        }
      });
    }
    return false;
  });
  $("#work_email").focusout(function () {
    var flag = 0;
    var work_email = $("#work_email").val();
    if (work_email.trim() == '') {
      $(".email-error").removeClass("hidden");
      flag = 1;
    } else {
      if (!isValidEmailAddress(work_email)) {
        $(".email-error").removeClass("hidden");
        flag = 1;
      } else {
        $(".email-error").addClass("hidden");
      }
    }
    if (flag == 1) {
      return false;
    } else {
      jQuery.ajax({
        type: 'POST',
        dataType: 'json',
        url: pw_script_vars.ajaxurl,
        data: {
          action: 'chk_email_name',
          work_email: work_email
        },
        success: function (result) {
          if (result.error_email === '2') {
            $(".work_error").html(result.error_email_msg);
            $(".email-error").attr("data-original-title", "This email address is already taken");
            $(".email-error").removeClass("hidden");
            /* setTimeout(function(){
               window.location.href = "https://app.hibob.com/";
               }, 5000); */
            } else if (result.error_email === '1') {
            $(".work_error").html(result.error_email_msg);
            $(".email-error").attr("data-original-title", "Please enter a valid work email");
            $(".email-error").removeClass("hidden");
            } else {
              $(".work_error").html('');
              $(".email-error").attr("data-original-title", "Please enter a valid work email");
              $(".email-error").addClass("hidden");
            }
                 }
      });
    }
    return false;
  });
  $("#password-reg").keyup(function () {
    var pass_reg = $("#password-reg").val();
    if (pass_reg.trim() == '') {
      $(".pw-error").removeClass("hidden");
      $(".pw-error").attr("data-original-title", "Missing Data");
    } else {
      if (pass_reg.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{8,}$/)) {
        $(".pw-error").attr("data-original-title", "Missing Data");
        $(".pw-error").addClass("hidden");
      } else {
        $(".pw-error").removeClass("hidden");
        $(".pw-error").attr("data-original-title", "Invoid password");
      }
    }
  });

}) (jQuery);

function frmThemeOverride_frmAfterSubmit(fin, p, errObj, obj) {

  var form_id = jQuery(obj).find('input[name="form_id"]').val();
  var form_key = jQuery(obj).find('input[name="form_key"]').val();
  var label = '';
  var contact_email, xhttp;

  if (form_id === '7') {
    jQuery('body').find('#myModalhome12').addClass('form-submitted');
    analytics.track('click - signup form', {
      "type": "track",
      "event": 'close form by X',
      label: 'להמשך גלישה באתר',
      category: 'IL site popup',
      "properties": {
        "action": 'click - signup form'
      }
    });

    jQuery('#myModalhome12 #close-button').on('click', function (e) {
      e.preventDefault();
      jQuery('#myModalhome12').modal("hide");
      analytics.track('click button - close popup', {
        "type": "track",
        "event": 'close form by red button after form submit',
        label: 'להמשך גלישה באתר',
        category: 'IL site popup',
        "properties": {
          "action": 'click button - close popup'
        }
      });
      return false;
    });
  }



  if (form_key === 'contactuskey') {

    contact_email = jQuery(obj).find('.is-email').find('input').val();
    label = 'contact support - Submit';
    analytics.track('email', {
      "type": "track",
      label: label,
      category: 'interested',
      "properties": {
        "action": 'email'
      }
    });
    jQuery('.contact-page-container .header-container').hide();
    jQuery('.contact-page-container form .frm_form_fields').hide();
    jQuery('.contact-page-container .page-content-container').removeClass('col-md-9 col-md-offset-1').addClass('col-md-6 col-md-offset-3 contact-form-submitted');
    jQuery('.contact-page-container .page-content-container .form-container').css('margin-top', '0');

    xhttp = new XMLHttpRequest();
    xhttp.open("POST", pw_script_vars.ajaxurl, true);
    xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhttp.send("action=lead_in_intercom&email=" + contact_email + "");
  }

  if (form_key === 'contactuskey2') {

    contact_email = jQuery(obj).find('.is-email').find('input').val();
    analytics.track('contact us', {
      "type": "track",
      label: 'contact us - pricing',
      category: 'interested',
      "properties": {
        "action": 'contact us'
      }
    });
    jQuery('.contact-page-container .header-container').hide();
    jQuery('.contact-page-container form .frm_form_fields').hide();
    jQuery('.contact-page-container .page-content-container').removeClass('col-md-9 col-md-offset-1').addClass('col-md-6 col-md-offset-3 contact-form-submitted');
    jQuery('.contact-page-container .page-content-container .form-container').css('margin-top', '0');
    jQuery(document).on('click', '.pricing-contact-close', function (e) {
      jQuery(".banner-section").fadeIn(3000).removeClass("hidden");
      jQuery(".contact-section").fadeOut(3000).addClass("hidden");
    });
    jQuery("#field_ina7p2").focus(function () {
      jQuery("#frm_field_79_container").removeClass("frm_required_field");
    });

    xhttp = new XMLHttpRequest();
    xhttp.open("POST", pw_script_vars.ajaxurl, true);
    xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhttp.send("action=lead_in_intercom&email=" + contact_email + "");
  }



  if (form_key === 'hebsignup') {
    if (jQuery('#hebrew-form-wrapper').hasClass('sticky-top')) {
      jQuery('#hebrew-form-wrapper').find('input#field_form_position').val('Top sticky form');
      label = 'sticky top';
    } else if (jQuery('#hebrew-form-wrapper').hasClass('sticky-bottom')) {
      jQuery('#hebrew-form-wrapper').find('input#field_form_position').val('Bottom sticky form');
      label = 'sticky bottom';
    }
    analytics.track('click - form submit', {
      "type": "track",
      label: label,
      category: 'IL landing V2',
      "properties": {
        "action": 'click - form submit'
      }
    });
  }

}
// stop video
function stopVideoPopup(video_url) {
  //  analytics.track('app referral', {
  //    "type": "track",
  //    label: 'video popup',
  //    category: 'interested',
  //    "properties": {
  //      "action": 'app referral'
  //    }
  //  });
  jQuery("#video-modal").find('iframe').attr('src', '');
  jQuery("#video-modal").find('iframe').attr('src', video_url);
  jQuery('#video-modal').modal('hide');
  jQuery('#video-modal-sm').modal('hide');
  //  jQuery('#registration-modal').modal('show');

  //redirecttoLink('https://app.hibob.com/register');
}
function stopVideoPopupsm(video_url) {
  //  analytics.track('app referral', {
  //    "type": "track",
  //    label: 'video popupsm',
  //    category: 'interested',
  //    "properties": {
  //      "action": 'app referral'
  //    }
  //  });
  jQuery("#video-modal-sm").find('iframe').attr('src', '');
  jQuery("#video-modal-sm").find('iframe').attr('src', video_url);
  jQuery('#video-modal-sm').modal('hide');
  //  jQuery('#registration-modal').modal('show');
  //redirecttoLink('https://app.hibob.com/register');
}

jQuery(window).resize(function () {
  var window_width = jQuery(window).width();
  var container_margin = jQuery('#wide-section-wrapper .container').width();
  container_margin = (window_width - container_margin) / 2;
  var right_image_section_width = jQuery('#wide-section-wrapper .right-image-container').width();
  var right_content_width = jQuery('#wide-section-wrapper .section-content-container').width();
  var demo_content_width = right_image_section_width + right_content_width;
  var left_image_width = window_width - demo_content_width - 170 - container_margin + 15;
  jQuery('#wide-section-wrapper .left-image-container').css('width', left_image_width);
});
function openHomeModelPopup() {
  jQuery("#video-modal").modal('show');
  var video_src = jQuery("#video-modal").find('.modal-body').attr('data-video-url');
  video_src = video_src + '?autoplay=true';
  jQuery(".fluid-width-video-wrapper").css("padding-top", "0px");
  jQuery("#video-modal").find('iframe').attr('src', video_src);
  sizeTheVideo();
}

jQuery(function( $ ) {
  var uk_user = getCookie('uk_user');
});


function isValidEmailAddress(emailAddress) {
  var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
  return pattern.test(emailAddress);
}

jQuery(".register-form input")
  .focusin(function () {
    jQuery(this).addClass('reg-input-text');
    jQuery(this).parents('.frm-required').addClass('star-pseudo');
  })
  .focusout(function () {
    jQuery(this).removeClass('reg-input-text');
    if (jQuery(this).val() === '') {
      jQuery(this).parents('.frm-required').removeClass('hide-pseudo');
      jQuery(this).parents('.frm-required').removeClass('star-pseudo');
    }
  })
  .keyup(function () {
    jQuery(this).parents('.frm-required').addClass('hide-pseudo');
  })
  .keydown(function () {
    if (jQuery(this).val() === '') {
      jQuery(this).parents('.frm-required').removeClass('hide-pseudo');
      jQuery(this).parents('.frm-required').removeClass('star-pseudo');
    }
  });

function isInViewport(elem) {
  var bounding = elem.getBoundingClientRect();
  return (
    bounding.top >= 0 &&
    bounding.left >= 0 &&
    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

function goToTagPage(id, event) {
    event.stopPropagation();
    event.preventDefault();
    let url = $(id).attr("data-url");
    //alert(url);
    window.location = url;
}

jQuery(document).ready(function(){
    jQuery('.go-to-form').click(function(e) {
        e.preventDefault();
        jQuery('html, body').animate({
          scrollTop: jQuery('.form-lp').offset().top
        }, 400);
    });
});

(function ($) {
  jQuery(document).ready(function(){
    if( $('#banners-carousel-1').length >= 1) {
      $('#banners-carousel-1').slick({
        dots: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 2000,
        infinite: true,
        speed: 1300,
        slidesToShow: 3,
        centerMode: true,
        variableWidth: true,
        centerPadding: 0,
        rtl: true
      });
    }
    if( $('#banners-carousel-2').length >= 1) {
      $('#banners-carousel-2').slick({
        dots: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 2000,
        infinite: true,
        speed: 1300,
        slidesToShow: 3,
        centerMode: true,
        variableWidth: true,
        centerPadding: 0,
      });
    }
  });
}) (jQuery);